// Chinese content for all pages — mirrors content-en.js
const ZH = {
  home: {
    title: "ABS Solutions — 专业会计税务事务所",
    metaDescription: "ABS Solutions家族会计师事务所，逾12年为墨尔本与布里斯班个人及企业提供税务、簿记、SMSF与商业咨询服务，中英双语，立即预约15分钟免费咨询。",
    h1: "释放您的业务增长潜能。",
    kicker: "ABS Solutions",
    intro: "为澳大利亚个人与企业量身定制会计、税务与商业咨询服务——基于十二年的信赖。",
    cards: [
      { kicker: "值得信赖", heading: "服务澳洲企业逾十二年", body: "Absolute Business Services（ABS）是一家家族式会计事务所，提供会计、簿记、税务及SMSF咨询。客户信赖我们以精准与关怀管理其税务与财务。" },
      { kicker: "专业团队", heading: "注册会计师与税务专家", body: "我们的团队拥有CPA、注册税务代理及SMSF专项顾问资质，并具备零售、制造、科技及房地产等多行业实战经验。" },
      { kicker: "定制化服务", heading: "一支团队，量身解决方案", body: "公司及个人税务申报、BAS、簿记、ABN/ACN/GST注册、SMSF管理与审计——全部以一致的定制化套餐交付。" },
    ],
    insightsHeading: "前沿洞察，深度解析。",
    insightsIds: ["negative-gearing", "smsf", "family-trust", "home-office-tax", "small-business-tax", "tax-deadlines"],
    videosKicker: "影片与分享",
    videosTitle: "税务，原来可以这么简单。",
    videosIntro: "由 ABS Solutions 团队带来的视频分享——帮助您拓展业务、保持合规，并在报税季中获得更多。",
    videos: [
      { id: "g1IdMn9u7aY", thumb: "/images/videos/g1IdMn9u7aY.jpg", caption: "ABS Solutions", ctaLabel: "在 YouTube 观看" },
      { id: "sLvnEF9H11g", thumb: "/images/videos/sLvnEF9H11g.jpg", caption: "ABS Solutions", ctaLabel: "在 YouTube 观看" },
      { id: "qNUJdsLB4s4", thumb: "/images/videos/qNUJdsLB4s4.jpg", caption: "ABS Solutions", ctaLabel: "在 YouTube 观看" },
    ],
    reviewsHeading: "逾十二年\n深受澳大利亚企业信赖",
    reviews: [
      {
        name: "Chun-Yi Chiu",
        color: "#1A73E8",
        text: "Louie 和他的团队帮我处理税务与财务规划。我原以为永远买不起自己的房子，但 ABS Solutions 让这一切成为可能。如果您需要一家真正懂税务与金融的会计师事务所，请务必联系 ABS Solutions。谢谢整个团队。",
      },
      {
        name: "Jessie Chen",
        color: "#E91E63",
        text: "我是经朋友介绍来到 ABS Solutions 的，因为之前的会计师让我不太满意。我先和 Louie 沟通——他非常耐心地介绍了 ABS 的服务方式，并把我引荐给 Kenny 负责今年的报税。Kenny 沟通非常顺畅，回复及时，所有问题都解释得很清楚。他不仅完成了报税，还帮助我理解如何优化税务、为未来更好地规划。这才是好的会计师应该做的。非常感谢他们的帮助，强烈推荐 ABS Solutions，尤其是 Kenny。再次感谢 Louie 和 Kenny！",
      },
      {
        name: "Christina Li",
        color: "#34A853",
        text: "我和伴侣在 ABS Solutions 的体验非常棒，肯定会长期合作。他们帮助我们处理税务与财务，从始至终回应迅速、沟通顺畅。特别感谢 Louie 总是带着丰富的专业知识与耐心解答我所有的问题——真的非常感谢您的专业！",
      },
      {
        name: "Danial",
        color: "#FBBC04",
        text: "ABS Solutions 在物业架构与融资规划方面给了我们极大的帮助。他们花时间深入了解我们的目标，并把复杂的结构讲解得通俗易懂。建议既具战略性又实用，并针对我们的实际情况量身定制，确保投资以最有效的方式落地。他们还协助我们整理财务，让整个流程顺畅无忧。专业、专注、真正以客户为先——强烈推荐 ABS Solutions。",
      },
      {
        name: "Leona Luo",
        color: "#9C27B0",
        text: "作为一名餐厅经营者，我深感 ABS Solutions 可靠且专业。Louie、Kenny 和 Andy 及其团队真正理解餐饮行业的特点，总能提供切实可行的税务与商业建议。他们高效、回应迅速，让我们管理财务毫无压力。强烈推荐！",
      },
      {
        name: "Teng",
        color: "#FF7043",
        text: "说真的，ABS Solutions 简直是救星！作为一名兼职工作的大学生，我对报税完全没有头绪。他们非常友好，把所有事情都解释得通俗易懂。整个流程快速便捷，处理完后我对自己的财务也更有信心了。强烈推荐给所有想轻松搞定报税的学生！",
      },
    ],
  },

  about: {
    title: "关于我们 — ABS Solutions",
    metaDescription: "了解ABS Solutions背后的团队：一家家族式经营的墨尔本会计事务所，逾十年助力澳大利亚企业蓬勃发展。",
    h1: "信赖建立的家族事务所。",
    intro: "Absolute Business Services（ABS）逾12年为澳大利亚企业提供税务、会计与合规服务。",
    sections: [
      { heading: "深受企业信赖", body: ["我们为中小型及家族企业提供会计、簿记、税务与SMSF咨询。客户信赖我们高效且合规地管理财税。", "多年来我们在澳大利亚会计行业树立了卓越的声誉。"] },
      { heading: "资深专业团队", body: "团队由注册会计师、注册税务代理及簿记专家组成，结合扎实的技术深度与务实的商业判断力。" },
      { heading: "量身定制服务", body: "每家企业都不同。我们与客户紧密合作，提供个性化方案——公司与个人税务申报、BAS、簿记、ABN/ACN/GST注册、SMSF及商业咨询。" },
    ],
    teamHeading: "认识我们的专业团队",
    teamGroupPhoto: "/images/staff/team-group.jpg",
    team: [
      { name: "Graham Yuan 袁先生", role: "董事总经理", photo: "/images/staff/graham-yuan.jpg", bio: "Graham 是 ABS Solutions 的董事总经理，澳大利亚公共会计师协会（FIPA）资深会员，拥有逾 20 年会计、税务与商业咨询经验。作为合资格的 SMSF 顾问与审计师，Graham 为个人、家庭与企业提供退休金、合规与税务高效策略的专业指导。凭借对复杂监管环境的深入理解与以客户为中心的服务方式，他擅长税务规划、企业架构、合规管理与自管养老金（SMSF）。工作之外，Graham 喜欢与妻子一起出海游船，享受放松与探索的时光。" },
      { name: "Louie Yuan 袁先生", role: "业务发展经理 | 合伙人", photo: "/images/staff/louie-yuan.jpg", bio: "Louie 是一位充满活力的创业者，与父亲 Graham 共同创立 ABS Solutions，致力打造一站式综合服务事务所，涵盖会计、税务、金融、SMSF 与咨询。家庭价值观是 ABS Solutions 的核心——Louie 的妻子 Kary 凭借其在金融与行政方面的专长，进一步提升了公司的运营能力。袁氏家族将 ABS Solutions 打造成澳大利亚企业可靠且具有前瞻性的合作伙伴。" },
      { name: "Andy Li 李先生", role: "高级税务代理 | 合伙人", photo: "/images/staff/andy-li.jpg", bio: "Andy 是 ABS Solutions 的高级税务代理，注册会计师（CPA），在税务、会计与财务咨询方面拥有深厚专长。他在制造业与建筑业拥有丰富经验，能够为面对复杂税务与合规环境的客户提供量身定制的实用方案。Andy 在成本管理、项目会计、库存控制与资本投资规划方面具有实战经验，帮助企业优化运营、提升财务表现。工作之外，他热衷探索人工智能与编程，并与妻子、女儿和儿子共享美好时光。" },
      { name: "Kenny Wong 黄先生", role: "高级税务代理 | 合伙人", photo: "/images/staff/kenny-wong.jpg", bio: "Kenny 是 ABS Solutions 的高级税务代理，注册会计师（CPA），拥有逾 10 年税务、会计与商业咨询经验。他专注于为中小企业提供个性化税务策略，确保合规并推动财务增长。Kenny 以战略思维、细致严谨及高效贴心的建议著称，对澳大利亚税法的深刻理解结合以客户为先的理念，使他成为众多企业信赖的顾问。工作之余，他喜欢与妻子和两个儿子一起露营、亲近自然。" },
      { name: "Lexi Yang 杨女士", role: "助理会计师", photo: "/images/staff/lexi-yang.jpg", bio: "Lexi 服务于跨行业的客户，专注于现金流可见性、会计精确性及税务支持。她拥有墨尔本皇家理工大学（RMIT）专业会计硕士学位，并持有中国证券从业资格证书。她涵盖核心会计运营、财务报告与合规事项，帮助客户保持财务清晰与运营掌控。她同时参与外部及内部审计准备、文件整理与合规支持，为每位客户提供贴合业务实际的解决方案。" },
    ],
  },

  "services-pricing": {
    title: "我们的收费价格 — ABS Solutions",
    metaDescription: "企业设立、会计、簿记、税务及审计服务的透明价格。所有价格含GST。",
    h1: "我们的收费价格。",
    intro: "为澳大利亚企业与个人提供透明、含GST的全包式定价。",
    categories: [
      { heading: "商业服务", items: [
        { name: "商业咨询（最多1小时）", price: "$220", desc: "企业设立、商业预算与财务模型、税务规划、贷款结构、簿记、会计软件培训（QuickBooks、MYOB、Xero）。" },
        { name: "企业设立 — 个体经营", price: "$550", desc: "商业名称注册、ABN、GST、TFN注册。" },
        { name: "企业设立 — 信托、合伙、公司", price: "$1,500", desc: "包括商业名称、ABN、ACN、GST、信托契约与TFN注册。" },
        { name: "企业设立 — SMSF套餐", price: "$6,600", desc: "SMSF信托名称、ABN、ACN、GST、TFN、公司受托人、SMSF信托契约、Bare/Custodian信托契约及2小时咨询。" },
        { name: "远程CFO（每月1.5小时）", price: "$330", desc: "远程公司财务管理、会计系统优化建议、决策监督。" },
        { name: "商业计划书", price: "$2,200", desc: "为创业者制定战略与执行方案。" },
        { name: "商业计划与预算模型", price: "$6,600", desc: "完整商业计划加财务建模，评估盈利能力并支持创业贷款。" },
      ]},
      { heading: "会计服务", items: [
        { name: "簿记 — BAS（无交易）", price: "$110", desc: "季度BAS的准备与提交。" },
        { name: "簿记 — BAS", price: "From $275", desc: "季度BAS的准备与提交。" },
        { name: "簿记 — 薪资", price: "From $22", desc: "第一名员工$22，每增加一名员工$12。" },
        { name: "簿记 — 中期财务", price: "$1,100", desc: "由注册会计师准备的过去12个月管理财务报表。" },
        { name: "STP年度结算", price: "$220", desc: "年度STP审查、处理与ATO提交。" },
        { name: "养老金申报", price: "$220", desc: "季度养老金申报至ATO及清算基金。" },
        { name: "年度工伤保险", price: "$220", desc: "年度工资汇总准备与WorkCover提交。" },
        { name: "利润预测（每次）", price: "From $1,100", desc: "结合YTD数据进行利润预测。" },
        { name: "CGT结算证明", price: "$275", desc: "为CGT房产出售准备并提交结算证明。" },
        { name: "外国居民CGT税率调整", price: "$495", desc: "申请降低外国居民CGT预扣税率。" },
      ]},
      { heading: "税务服务", items: [
        { name: "个人报税 — 无PAYG/学生", price: "$100", desc: "适用于学生卡持有人及无营业实体。" },
        { name: "个人报税 — PAYG简易", price: "$200", desc: "仅工资单，无其他投资。" },
        {
          name: "个人报税 — PAYG 附加项",
          isAddOnCard: true,
          addOns: [
            { name: "租赁物业", price: "$165", desc: "每套物业" },
            { name: "股票及其他收入（按小时）", price: "$110", desc: "" },
          ],
        },
        { name: "物业折旧报告", price: "$700", desc: "符合ATO要求的详细折旧报告，最大化扣减。" },
        { name: "个体经营简易申报", price: "From $660", desc: "为个体经营企业准备并提交税表。" },
        { name: "信托、公司、合伙申报", price: "$2,200", desc: "为信托/公司/合伙企业准备并提交税表。" },
        { name: "SMSF申报", price: "$2,200", desc: "为复杂SMSF实体准备并提交税表。" },
      ]},
      { heading: "审计服务", items: [
        { name: "律师事务所信托账户", price: "From $660", desc: "符合《2006年律师事务所法案》的合规审计。" },
        { name: "房地产经纪信托账户", price: "From $880", desc: "符合《1980年房地产经纪法案》的合规审计。" },
        { name: "SMSF审计", price: "From $1,100", desc: "独立、合规的ATO要求审计。" },
        { name: "非营利组织审计", price: "From $2,200", desc: "透明、可靠的非营利组织合规审计。" },
      ]},
    ],
  },

  contact: {
    title: "联系我们 — ABS Solutions",
    metaDescription: "联系ABS Solutions。布里斯班与墨尔本Canterbury办公地点。电话、邮件及地址详情如下。",
    h1: "开启我们的对话。",
    intro: "通过电话、电邮或亲临任一办公室与我们的团队取得联系。",
    offices: [
      { name: "Canterbury总部", company: "Absolute Business Services (ABS) Solutions", address: "205 Canterbury Road, Canterbury Victoria 3126, Australia", landline: "+61 3 9826 1316", mobile: "+61 430 032 721", email: "info@abs-solutions.com.au", mapQuery: "205 Canterbury Road, Canterbury VIC 3126, Australia" },
      { name: "布里斯班办公室", company: "Absolute Business Services (ABS) Solutions", address: "Level 19, 10 Eagle Street, Brisbane City QLD, Australia", extra: "布里斯班办公室开放时间：仅限预约", landline: "+61 7 3087 3404", mobile: "+61 430 032 721", email: "info@abs-solutions.com.au", mapQuery: "10 Eagle Street, Brisbane City QLD, Australia" },
    ],
    hours: [["周一","10:00 am – 05:00 pm"],["周二","10:00 am – 05:00 pm"],["周三","10:00 am – 05:00 pm"],["周四","10:00 am – 05:00 pm"],["周五","10:00 am – 05:00 pm"],["周六","预约制"],["周日","预约制"]],
  },

  "melbourne-accounting-firm": {
    title: "墨尔本会计师事务所｜华人团队 — ABS Solutions",
    metaDescription: "扎根墨尔本Canterbury逾12年，CPA注册会计师团队Google评分5.0分，为东区华人个人与企业提供报税、做账、SMSF与信托服务，可面谈或线上远程办理。",
    h1: "墨尔本领先的会计师事务所。",
    intro: "ABS Solutions——您值得信赖的财税战略合作伙伴、结合本地深耕经验与全周期会计、税务、咨询服务。如果你人在墨尔本,正在找一位真正听得懂华人客户需求的会计师事务所,ABS Solutions从2012年起就扎根在Canterbury(墨尔本东区),团队里的注册会计师是CPA Australia正式会员,每天都在用中文和英文为本地华人个人与企业处理报税、做账、公司架构设立与税务规划。不管你住在Box Hill、Balwyn、Doncaster、Camberwell还是Glen Waverley这些华人聚居较集中的东区,都可以直接上门面谈,也完全可以线上远程办理,不受地点限制。我们经手的业务覆盖个人报税、小生意与公司账目、GST/BAS申报、家庭信托与自管养老金(SMSF)设立,以及涉及中澳两地资产的税务规划——不少客户就是因为终于有人能用中文把复杂的澳洲税法讲清楚,才从其他事务所转过来找我们。目前我们在Google上的评分是5.0分,这也是这些年本地华人客户口碑一点点积累出来的结果。",
    sections: [
      { heading: "全方位会计与税务服务", body: "从精准审计到复杂税务策略，我们的专业服务覆盖企业全生命周期。无论您是初创还是成熟企业，我们都将与您携手共进。", bullets: ["合规审计 — 年度财务审计、BAS/GST申报、法定年检","税务优化 — 企业/个人税务筹划、跨境税务方案、税务争议解决","商业支持 — ABN/ACN注册、薪酬体系设计、SMSF全周期管理","战略咨询 — 企业架构重组、现金流优化、退出战略规划"] },
      { heading: "值得信赖的墨尔本团队", body: "由CPA Australia会员、注册税务代理（TPB认证）及持牌SMSF顾问组成，在零售、制造与科技等领域拥有实战经验。" },
    ],
  },

  "brisbane-accounting-firm": {
    title: "布里斯班会计师事务所｜华人团队 — ABS Solutions",
    metaDescription: "位于布里斯班CBD Eagle Street，CPA注册会计师熟悉QLD地税与薪资税规则，为Sunnybank等华人聚居区企业提供报税、BAS与SMSF服务，可预约面谈。",
    h1: "布里斯班领先的会计师事务所。",
    intro: "如果你人在布里斯班,正在找一位真正了解本地华人客户与昆士兰(QLD)税务规则的会计师事务所,ABS Solutions在布里斯班CBD的Level 19, 10 Eagle Street设有办公室,团队里的注册会计师是CPA Australia正式会员,专门处理昆州企业与个人的报税、做账及税务规划。和维州不同,昆士兰有自己的一套地税与薪资税规则——比如个人地税免税额为60万澳元、公司与信托为35万澳元,海外/非居民业主还要另外缴3%的附加地税;薪资税方面,年度门槛是130万澳元,超过部分按4.75%计税(年薪资超650万澳元则为4.95%),这些规则和南边各州都不一样,如果找一个不熟悉昆州规则的会计师,很容易在申报时踩坑。我们服务的客户不少来自布里斯班南区华人聚居较集中的Sunnybank、Robertson、Runcorn、Macgregor和Eight Mile Plains一带,不管是个人报税、小生意与公司账目、GST/BAS申报,还是家庭信托与自管养老金(SMSF)设立,都可以直接来Eagle Street办公室面谈,也可以线上远程处理。",
    sections: [
      {
        heading: "全方位会计与税务服务",
        body: "从精准审计到复杂税务策略，我们的专业服务覆盖企业全生命周期。无论您是昆士兰初创团队首次报税，还是寻求进一步成长的成熟企业，我们都将与您携手共进。",
        bullets: [
          "合规审计 — 年度财务审计、BAS/GST 申报、法定年检",
          "税务优化 — 企业/个人税务筹划、跨境税务方案、税务争议解决",
          "商业支持 — ABN/ACN 注册、薪酬体系设计、SMSF 全周期管理",
          "战略咨询 — 企业架构重组、现金流优化、退出战略规划",
        ],
      },
      {
        heading: "值得信赖的布里斯班团队",
        body: "我们的团队由 CPA Australia 会员、注册税务代理（TPB 认证）及持牌 SMSF 顾问组成，在零售、制造与科技等领域拥有实战经验，为客户提供精准的行业洞察与解决方案。",
      },
      {
        heading: "为什么昆士兰企业选择 ABS Solutions",
        bullets: [
          "家族式精品事务所，拥有逾十年的澳大利亚全国服务经验",
          "团队成员包括 CPA Australia 会员、TPB 注册税务代理及持牌 SMSF 审计师",
          "中英双语顾问服务，专为昆士兰华人企业社群提供支持",
          "端到端服务 — 会计、BAS/GST、SMSF、审计、企业设立与战略咨询",
          "含 GST 的透明定价，无隐藏费用",
        ],
      },
      {
        heading: "我们为布里斯班客户提供的核心服务",
        list: [
          { heading: "税务与 BAS / GST 合规", body: "公司、信托、合伙与个人税表准备及申报。季度 BAS、GST 注册及 PAYG 管理——由我们全程代为向 ATO 提交。" },
          { heading: "簿记与薪资", body: "Xero、MYOB 与 QuickBooks 簿记、薪资、Single Touch Payroll（STP）、养老金与 WorkCover——由专业团队设立并持续维护。" },
          { heading: "SMSF 设立与审计", body: "自管养老金设立、受托人架构、年度合规与独立 SMSF 审计。" },
          { heading: "企业设立与咨询", body: "个体经营、公司、合伙与信托结构设立。商业计划书、财务建模、现金流预测与远程 CFO 支持。" },
          { heading: "审计与鉴证", body: "房地产信托账户审计、过户师审计与非营利组织/协会审计——依据澳大利亚审计准则执行。" },
        ],
      },
      {
        heading: "我们在布里斯班的合作流程",
        list: [
          { heading: "1. 咨询", body: "上门或线上会议，深入了解您的业务、财务现状与目标。" },
          { heading: "2. 定制方案", body: "根据您的规模与复杂度，提供针对性的服务计划与透明固定报价。" },
          { heading: "3. 执行落地", body: "合伙人与高级会计师处理税务、BAS、簿记、SMSF 或审计——让您专注于经营。" },
          { heading: "4. 长期合作", body: "在法规更新、ATO 裁定及业务发展过程中，全年随时提供顾问支持。" },
        ],
      },
    ],
  },

  "canterbury-accounting": {
    title: "Canterbury会计与簿记服务 — ABS Solutions",
    metaDescription: "Canterbury本地的精品会计与簿记服务。税务申报、BAS/GST、SMSF与审计——一站式服务。",
    h1: "Canterbury的簿记与会计服务。",
    intro: "位于Canterbury核心地段的定制会计服务。无论您经营小生意或需要全面合规支持，本地团队随时为您服务。",
    sections: [
      { heading: "为何选择ABS Solutions", bullets: ["逾11年经验的家族式精品事务所","注册会计师、税务专家及簿记专员","可定制方案——簿记、BAS/GST、税表、SMSF、审计","Canterbury办公室205 Canterbury Road，便于面对面沟通"] },
      { heading: "我们的核心服务", list: [
        { heading: "簿记与BAS/GST合规", body: "日常账务、总账维护、对账与BAS/GST申报。" },
        { heading: "税务申报与BAS", body: "公司与个人税务申报、BAS管理、全面合规。" },
        { heading: "SMSF咨询", body: "专业指导与管理，确保基金合规并优化业绩。" },
        { heading: "审计与合规", body: "为您的财务报告提供信心保障。" },
        { heading: "定制咨询与家族办公室", body: "为您量身打造的财务咨询与家族办公室级别支持。" },
      ]},
      { heading: "我们的工作流程", list: [
        { heading: "1. 咨询", body: "讨论您的业务需求、财务现状与目标。" },
        { heading: "2. 定制方案", body: "提出适合您规模的簿记/会计计划。" },
        { heading: "3. 执行管理", body: "处理簿记、BAS、税务、SMSF或审计，让您专注增长。" },
        { heading: "4. 持续支持", body: "在业务演进中持续提供合规更新与财务建议。" },
      ]},
    ],
  },

  "chinese-accountants-aus": {
    title: "澳洲华人会计师事务所 — ABS Solutions",
    metaDescription: "服务澳大利亚华人个人与企业的双语会计事务所。全方位税务、会计与SMSF咨询。",
    h1: "服务澳洲华人社区的双语会计师团队。",
    intro: "如果你是华人,不管刚移民澳洲、持工作签证还是已经拿到PR,澳洲的税务合规环境用中文理解起来完全是两码事——这也是ABS Solutions这些年专门组建双语会计师团队,在墨尔本Canterbury和布里斯班Eagle Street两个办公室,用普通话、粤语加英文为华人客户提供服务的原因。我们经手最多的,往往不是普通报税这么简单,而是华人客户特别容易踩坑的几类问题:比如海外人士在澳洲买房要不要申请FIRB(外国投资审查委员会)批文——这项针对外国人购买二手房的禁令原本定在2027年3月解禁,但在2026-27联邦预算中已经被延长到2029年6月30日,不少还以为再等一年多就能买现房的客户,其实得重新调整计划;又比如从中国往澳洲汇款、澳洲银行账户信息按CRS(共同申报准则)与中国税务机关自动交换、以及跨境税务居民身份的认定,这些都不是普通英文报税软件、或者不熟悉中澳两国规则的会计师能讲清楚的。不管你人在墨尔本、布里斯班还是澳洲其他城市,我们都可以用你熟悉的语言,把这些复杂规则讲明白,再帮你把个人报税、公司账目、家庭信托和跨境资产规划真正落地。",
    sections: [
      { heading: "我们提供的服务", bullets: ["个人与公司税务申报","企业设立——ABN、ACN、GST、TFN","簿记与BAS/GST申报","SMSF设立、行政与审计","跨境税务规划","家族信托结构与遗产规划"] },
      { heading: "客户为何选择我们", body: "我们的合伙人与高级团队拥有扎实的澳洲税法知识及流利的中英文沟通能力，将复杂法规化作清晰可执行的建议。" },
    ],
  },

  "melbourne-accounting-tax": {
    title: "墨尔本会计与税务服务 — ABS Solutions",
    metaDescription: "墨尔本全方位会计与税务服务——从BAS与簿记到企业税表与SMSF咨询。",
    h1: "墨尔本企业的会计与税务服务。",
    intro: "我们的墨尔本团队提供端到端的会计与税务支持——保持合规、高效与信息透明。",
    sections: [
      { heading: "我们的核心价值", bullets: ["年度财务报表与税务申报","季度BAS与月度薪资申报","贯穿全年的税务规划","业务表现评估与对标","行业专项扣减分析"] },
      { heading: "与我们合作", body: "从首次咨询开始，您将拥有一位专属会计师——深入了解您的业务、目标与所在行业，由ABS Solutions全团队提供支持。" },
    ],
  },

  "individual-tax": {
    title: "个人报税服务 — ABS Solutions",
    metaDescription: "为澳大利亚居民与海外澳洲人提供专业的个人税务申报与税务规划。",
    h1: "个人报税服务。",
    intro: "无论您居住在澳大利亚还是海外，我们的注册税务代理都能精准处理您的个人税务申报。",
    sections: [
      { heading: "我们的专业服务", list: [
        { heading: "个人所得税申报与准备", body: "注册税务代理与会计师精准准备并提交申报表，确保符合ATO要求。" },
        { heading: "最大化退税与税务优惠", body: "根据您的具体情况合法运用所有可用的扣减与抵免。" },
        { heading: "个性化税务咨询", body: "每位客户情况不同，我们提供量身定制的税务建议。" },
        { heading: "高效便捷的报税流程", body: "您只需提供资料，团队处理后续所有申报工作。" },
      ]},
      { heading: "为什么选择ABS Solutions", body: "我们会先提供清晰的资料清单，全过程税务顾问随时解答疑问，确保您合规并享受应有的退税。" },
    ],
  },

  "melbourne-company-personal-tax": {
    title: "墨尔本公司及个人报税 — ABS Solutions",
    metaDescription: "墨尔本端到端的公司与个人税务服务——策略、规划与合规申报。",
    h1: "墨尔本公司及个人报税。",
    intro: "如果你在墨尔本经营生意或打理个人财务,找一家真正熟悉维州(VIC)规则的会计师事务所很关键——ABS Solutions的总部就设在Canterbury Road,团队里都是CPA Australia注册会计师,专门处理墨尔本企业与个人的报税、做账及税务规划。维州自己有一套和其他州完全不同的税务门槛:地税方面,只要名下维州地产的总应税价值超过5万澳元起征点(信托持有则是2.5万澳元)就要开始缴地税,境外/非居民业主还要在此基础上额外加收4%的「非本地业主附加税」(Absentee Owner Surcharge);薪资税方面,年度门槛是100万澳元(月度8.33万澳元),税率4.85%,超过300万澳元后免税额度开始逐步递减、到500万澳元完全归零,全澳工资超过1000万澳元的雇主还要额外多缴最高1%的附加税(心理健康税与新冠债务税各0.5%)。这些数字和门槛跟昆州、新州都不一样,如果找一个不专门做维州业务的会计师,很容易在申报时漏算这些附加税种,或者错用别的州的规则来估算。不管你是个人报税、小生意账目,还是公司GST/BAS申报、家庭信托设立,我们都可以直接在Canterbury办公室面谈,也可以线上远程处理。",
    sections: [
      { heading: "我们的税务服务包括", list: [
        { heading: "个人报税", body: "工资、个体经营利润、租金及股息——申请所有符合资格的扣减项与豁免。" },
        { heading: "公司报税", body: "准备合规财务记录，计算应纳税所得额，完成公司税申报。" },
        { heading: "独资与合伙报税", body: "处理账务、申报可抵扣经营支出并按时提交准确报税表。" },
        { heading: "雇主税务合规", body: "STP、PAYG预扣税、养老金、BAS与IAS——全部为您处理。" },
        { heading: "投资物业税务建议", body: "租金申报、折旧报告、贷款利息抵扣与CGT规划。" },
        { heading: "个人税务优化与规划", body: "多渠道收入综合规划，制定长期税务策略。" },
      ]},
    ],
  },

  "company-tax": {
    title: "专业公司报税服务 — ABS Solutions",
    metaDescription: "专业的公司税务服务。年度申报、规划、扣减审查与结构咨询。",
    h1: "专业公司报税服务。",
    intro: "税务影响公司财务的方方面面。我们的专业团队帮助您合规、优化结构并提升财务效率。",
    sections: [
      { heading: "我们的工作方式", body: "税务顾问与您紧密沟通，了解业务与财务，结合最新ATO政策与申报流程。", bullets: ["公司所得税申报与年度报表","企业税务规划与策略建议","税务减免与抵扣识别","税务合规审查与优化","商业结构调整与咨询"] },
      { heading: "持续合规与支持", body: "我们助您履行纳税义务，最大限度降低税务风险，提供高效、透明、具战略性的服务。" },
    ],
  },

  "small-business-tax": {
    title: "澳洲小生意报税 — ABS Solutions",
    metaDescription: "为澳大利亚小生意提供专业税务服务。扣减、资产核销、差旅与居家办公建议。",
    h1: "澳洲小生意报税。",
    intro: "只要支出是为了产生或增加企业收入而发生，通常即可在当年财政年度申报扣减。我们确保您申报所有合理项目。",
    sections: [
      { heading: "通常可申报的项目", bullets: ["员工工资及养老金","市场推广及广告","会计及财务管理费用","办公室租金及运营成本","业务保险"] },
      { heading: "需要留意", body: "私人性质的支出不可申报扣减。混合支出仅可申报业务相关部分。请保存发票、合同与付款记录。" },
      { heading: "差旅费用", body: "因公出差的机票、火车、出租车及住宿费用通常可申报；过夜差旅期间的合理餐饮费用亦可申报。" },
      { heading: "居家办公", body: "如果您将家庭部分区域用作办公，可按比例申报房贷利息、租金、水电、网络与折旧费用，但需注意未来可能涉及的CGT影响。" },
    ],
  },

  "business-tax": {
    title: "澳洲企业怎么报税 — ABS Solutions",
    metaDescription: "澳大利亚企业税务义务实用指南。申报、BAS、FBT与PAYG详解。",
    h1: "澳洲企业怎么报税。",
    intro: "每家企业——无论个体、合伙、公司或信托——都对ATO负有税务义务。了解需要申报什么与何时申报至关重要。",
    sections: [
      { heading: "关键义务", bullets: ["年度所得税申报","季度BAS","员工PAYG预扣税","养老金保障供款","适用情况下的FBT"] },
      { heading: "常见挑战", body: "大多数企业在税款支付现金流、支出分类、合规与增长平衡方面遇到困难。我们为这一切提供单一联系点。" },
    ],
  },

  "tax-deadlines": {
    title: "澳洲2026报税截止日期 — ABS Solutions",
    metaDescription: "自行申报个人所得税须在2026年10月31日前完成；通过注册税务代理最迟可延至2027年5月15日。查看BAS、公司与信托申报完整日期表，避免罚款与利息。",
    h1: "澳洲报税截止日期。",
    intro: "错过申报截止日期会触发罚款与利息。请参考以下日期，并与我们合作确保不再错过。如果您自行准备并提交2025–26财年的个人所得税申报表，法定截止日期为2026年10月31日，适用于通过myGov在线申报、电话申报或纸质申报等所有方式；但如果您在10月31日前已正式登记成为注册税务代理的客户，并且此前没有任何逾期未申报的历年记录，通常可以纳入代理的税务局申报计划，将截止日期延长至2027年5月15日，这比自行申报多出约六个半月的准备时间；此外，对于部分适用5月15日截止日期的个人客户，如果在2027年6月5日之前同时完成申报并缴清应缴税款，税务局还提供进一步的宽限安排；需要注意的是，这一延期并非对所有代理客户自动适用——如果您有前一年度或更早年度尚未申报的记录，即使已聘请税务代理，仍须按10月31日的原定日期申报当年度税表；如果逾期未按时申报，税务局将按每28天（或不足28天的部分）收取一个罚款单位计算未按时申报罚款，自2026年7月1日起每个罚款单位为364澳元，个人及小型实体最高可累计五个单位、合计1,820澳元的罚款，并且未缴清的税款还会按日复利计算一般利息费（目前年利率约为10.96%，每季度调整一次）；即使暂时无力缴纳税款，也应尽量按时申报，因为未申报本身产生的罚款通常远高于欠税产生的利息，我们可以协助您与税务局协商制定合理的分期还款安排。",
    sections: [
      { heading: "个人申报", bullets: ["自行申报：每年10月31日","通过注册税务代理：通常为次年5月15日（取决于客户状态）","以往未结清的申报可能缩短未来截止日期"] },
      { heading: "公司/信托申报", bullets: ["通常为收入年度后的5月15日","大型/中型应税纳税人适用更早截止日期","新实体首年截止日期不同——请与我们确认"] },
      { heading: "BAS申报", bullets: ["月度BAS：次月21日","季度BAS：10月28日、2月28日、4月28日、7月28日","通过税务代理申报可获得延期"] },
    ],
  },

  "bas-lodgement": {
    title: "澳洲BAS申报代理 | 多拿宽限期— ABS Solutions",
    metaDescription: "通过ABS Solutions注册BAS代理电子申报，大部分季度可比自行申报多拿约4周宽限期，避免364澳元起的滞纳金，我们准确处理GST与PAYG申报。",
    h1: "商业运作表（BAS）申报。",
    intro: "在澳洲经营企业时，您可能经常听到 BAS 这个词。许多企业主或新创业者并不清楚 BAS 的具体含义及申报要求。本文将为您简要介绍 BAS 的概念、准备材料以及申报方式，帮助企业更好地履行税务义务。在澳洲经营生意,BAS(Business Activity Statement,商业活动报表)基本是绕不开的一份表——只要你的生意年营业额达到7.5万澳元(非营利组织是15万澳元)门槛,就必须注册GST,并按月度或季度定期向ATO申报BAS,内容通常包括你收取和支付的GST、代扣的员工PAYG预扣税,以及部分行业还要申报的燃油税抵免等项目。很多企业主一开始最容易搞混的,是「BAS」和「个人报税」根本是两回事——BAS报的是生意运作过程中每个申报周期发生的税款进出,频率更高、数字更琐碎,而个人或公司所得税申报则是财年结束后的年度总结,两者不能互相替代。季度BAS的标准截止日期是10月28日、2月28日、4月28日和7月28日,自己申报就按这个日期来;但如果通过我们这样的注册BAS代理电子申报,大部分季度可以再多拿到大约4周的宽限期。逾期申报同样会被ATO按每28天收取一个处罚单位(目前为364澳元)计收滞纳金,小型实体最高可累计到1,820澳元,这还没算上未缴税款另外产生的一般利息。我们接手BAS申报的客户,大多是想把这件每季度都要做、又容易在GST代码分类和PAYG扣缴金额上出错的事情彻底交出去,让自己能专心把生意做好。",
    sections: [
      {
        heading: "BAS 涵盖范围",
        body:
          "BAS（Business Activity Statement）是企业定期向 Australian Taxation Office（ATO）提交的商业活动申报表，用于报告和缴纳各类税项，包括：",
        bullets: [
          "GST（商品及服务税）",
          "PAYG 预扣税",
          "员工福利税（FBT）",
          "进口车辆税、葡萄酒均衡税（WET）、豪华车税（LCT）及其他适用税项",
        ],
      },
      {
        heading: "GST 部分需要披露的信息",
        body: "在 GST 部分，企业需要披露以下信息：",
        bullets: [
          "当期销售总额",
          "出口销售额",
          "零税率销售额",
          "资本性采购金额",
          "非资本性采购金额",
        ],
      },
      {
        heading: "简化版 BAS",
        body:
          "若企业的 GST 应税销售额低于 1,000 万澳元，通常可以使用简化版 BAS，以降低申报复杂度，同时保留完整的 GST 合规义务。",
      },
      {
        heading: "BAS 填报前需要准备的资料",
        body:
          "为了确保 BAS 申报准确无误，企业应提前整理以下文件。完整且清晰的记录不仅能提高申报效率，也有助于应对税务审查：",
        bullets: [
          "销售发票与收入记录",
          "采购发票与支出记录",
          "银行对账单",
          "工资记录与 PAYG 资料",
          "会计系统导出的财务报表",
        ],
      },
      {
        heading: "BAS 的申报方式",
        body: "企业可通过以下方式向 ATO 申报 BAS：",
        list: [
          { heading: "1. 在线申报", body: "通过 ATO Online Services 或集成会计软件（Xero、MYOB、QuickBooks）直接申报，是目前最常用的方式。" },
          { heading: "2. 通过注册税务代理（Tax Agent）", body: "通过税务代理申报可享受延长截止日期，并提供额外的专业审核。" },
          { heading: "3. 邮寄纸质表格", body: "适用于无数字渠道的企业，但效率较低、易出错。" },
          { heading: "4. 电话申报", body: "仅适用于零申报（当期无任何业务活动）。" },
        ],
      },
      {
        heading: "BAS 申报频率与截止日期",
        body: "BAS 申报频率取决于企业规模及 ATO 的要求：",
        bullets: [
          "月度申报：每月 21 日截止",
          "季度申报：每年 2 月、4 月、7 月、10 月的 28 日截止",
          "通过注册税务代理申报通常可获得延期",
        ],
      },
      {
        heading: "记录保存与更正申报",
        body:
          "企业需妥善保存 BAS 相关记录至少 5 年。如发现已提交的 BAS 存在错误，可以通过以下方式更正：",
        bullets: [
          "在后续 BAS 中进行调整（适用于小额或当期可修正项目）",
          "向 ATO 提交修正申报（Revision）以更正原始 BAS",
        ],
      },
      {
        heading: "我们如何帮助您",
        body:
          "作为专业会计服务提供商，ABS Solutions 致力于帮助企业准时、准确地完成 BAS 申报。企业主有责任向 ATO 报告包括 BAS、GST 和 PAYG 在内的税务信息。选择专业团队协助，可以让您专注于业务发展，而将税务合规交给值得信赖的专家。",
        bullets: [
          "准时、准确提交 BAS",
          "合规申报 GST 与 PAYG",
          "优化企业税务流程",
          "降低税务风险",
        ],
      },
    ],
  },

  "gst-registration": {
    title: "澳洲GST注册指南 — ABS Solutions",
    metaDescription: "年营业额达到7.5万澳元（非营利15万澳元）须注册GST。了解注册材料、自愿注册的好处及常见申报错误，ABS Solutions协助一次性完成GST与ABN注册。",
    h1: "澳洲 GST 注册与申报。",
    intro:
      "GST（商品及服务税）是适用于澳大利亚境内大部分商品、服务及相关交易的 10% 广基消费税。我们为您处理注册、按时申报与持续合规——让您专注于业务发展。",
    sections: [
      {
        heading: "何时必须注册 GST",
        body: "出现以下任一情形即须注册：",
        bullets: [
          "年 GST 营业额 $75,000 或以上（非营利机构为 $150,000）",
          "提供出租车、网约车或豪华车服务——不论营业额",
          "希望申请燃油税抵免（Fuel Tax Credits）",
          "从事符合 GST 注册条件的非营利活动",
        ],
      },
      {
        heading: "为何即使未达门槛也值得自愿注册",
        body:
          "对于初创或资本投入较大的企业（产生大量进项 GST），或主要服务对象为已注册 GST 企业的供应商，自愿注册可帮助回收进项 GST。",
      },
      {
        heading: "如何注册",
        body: "GST 注册通过 ABR 完成，可与 ABN 申请一并办理。需准备：",
        bullets: [
          "有效的 ABN",
          "企业法定名称与商号",
          "预估年 GST 营业额",
          "申报周期偏好（月度、季度、年度）",
          "会计方法（现金制或权责发生制）",
        ],
      },
      {
        heading: "我们的 GST 服务",
        body: "注册之后，GST 将进入您的常态税务周期，我们提供：",
        list: [
          { heading: "GST 注册", body: "通过 ABR 完成 ATO 注册并提供申报周期建议。" },
          { heading: "季度或月度 BAS", body: "通过 ATO Online Services 或会计软件准备并提交 BAS。" },
          { heading: "进项税抵免审查", body: "确保每一笔合规抵免都被申报，避免多缴税。" },
          { heading: "跨境 GST 咨询", body: "进口、出口、数字服务与免税供应——正确归类与申报。" },
          { heading: "GST 审计支持", body: "与 ATO 沟通、准备凭证并全程管理审计流程。" },
        ],
      },
      {
        heading: "常见错误",
        body: "不少中小企业因小细节多缴或少缴 GST，常见错误包括：",
        bullets: [
          "营业额超过门槛后未及时注册（产生罚款与补缴）",
          "对免税商品错误收取 GST 或反之",
          "采购发票缺少有效 ABN 或 GST 标识，无法申报进项抵免",
          "$82.50 以上的采购未取得合规税务发票",
          "BAS 迟报触发未按时申报（FTL）罚款",
        ],
      },
      {
        heading: "ABS Solutions 如何帮助您",
        body: "从首次注册到每个季度的常规申报与 ATO 审查：",
        bullets: [
          "GST + ABN 一站式注册",
          "季度 / 月度 BAS 申报",
          "进项税抵免审查与簿记修正",
          "跨境 GST 进出口建议",
          "中英文双语全程服务",
        ],
      },
    ],
  },

  tfn: {
    title: "什么是TFN税号 — ABS Solutions",
    metaDescription: "TFN税号申请完整指南，讲解澳洲居民、留学生与临时签证持有人的申请材料与流程，一般28天内处理完成，ABS Solutions协助中英文全程办理。",
    h1: "什么是 TFN？",
    intro: "TFN（税号）是由澳大利亚税务局（ATO）签发的个人税务识别号码。在澳洲工作、银行业务、投资及经营企业都不可或缺。本指南将解释 TFN 的作用、申请条件及流程，帮助您正确建立税务身份。",
    sections: [
      {
        heading: "为什么需要 TFN",
        body: "没有 TFN，您可能在工资、银行利息和部分投资收入上被按最高边际税率预扣。常见需要 TFN 的情形包括：",
        bullets: [
          "合法就业——雇主在发薪与税务申报时通常需要 TFN",
          "银行与投资——缺少 TFN 可能导致高额预扣税",
          "税务记录——退税、福利申请和收入匹配均需 TFN",
          "政府服务——办理税务申报及访问 ATO 在线服务",
        ],
      },
      {
        heading: "谁适合申请",
        body: "几乎所有就业年龄的澳洲居民及大多数临时签证持有人都应申请 TFN：",
        bullets: [
          "新移民、留学生、临时签证持有人及所有拥有合法工作权利者",
          "即将开始工作、兼职或自雇创业者",
          "需要开立银行、养老金或投资账户者",
          "计划以 Sole Trader、公司、信托或合伙经营，或申请 ABN 者",
        ],
      },
      {
        heading: "如何申请 TFN",
        body: "根据居留身份不同，申请方式略有差别：",
        list: [
          { heading: "澳洲居民", body: "通过 ATO 网站或 myGov 在线申请，需提交身份证明和居住地址。一般 28 天内处理完成。" },
          { heading: "外国护照持有人", body: "抵澳并获得带工作权的签证后，可通过 ATO 在线申请，需提供护照与签证资料。" },
          { heading: "打工度假签证持有人", body: "抵澳后即可在线申请。请注意打工度假者税率适用于此签证下的收入。" },
          { heading: "16 岁以下儿童或无标准身份证件者", body: "可能需通过纸质申请。ABS Solutions 可指导正确表单与材料。" },
        ],
      },
      {
        heading: "需要准备的资料",
        body: "充分准备能让申请顺利通过。申请前请准备：",
        bullets: [
          "政府签发的带照片身份证件（护照或驾照）",
          "澳大利亚居住地址证明",
          "签证详情（非居民）",
          "首次抵达澳洲日期（非居民）",
          "如曾持有 TFN，请勿重复申请",
        ],
      },
      {
        heading: "保护好您的 TFN",
        body: "TFN 是敏感的个人信息，请像银行密码一样妥善保管。ATO 永远不会通过邮件或电话索取您的 TFN。仅向雇主、注册税务代理、银行、养老金机构或政府部门提供。如怀疑 TFN 被盗用，请立即联系 ATO。",
      },
      {
        heading: "ABS Solutions 如何帮助您",
        body: "我们的注册税务代理让 TFN 申请流程简单清晰。我们提供资料清单、用中英文解释规则，并在 TFN 签发后协助您完成首次澳大利亚税务申报：",
        bullets: [
          "申请前的资料清单与预审",
          "中英文双语贯穿整个流程",
          "申请受阻时与 ATO 沟通协调",
          "后续税务规划与首次报税申报",
        ],
      },
    ],
  },

  abn: {
    title: "澳洲如何申请ABN | ABN申请指南  — ABS Solutions",
    metaDescription: "申请ABN，符合条件的澳洲居民在线申请当场即可获批。了解申请材料、结构选择及常见被拒原因，ABS Solutions协助一次性办妥ABN、GST与TFN注册。",
    h1: "如何在澳大利亚申请 ABN。",
    intro: "在澳大利亚经营企业通常包括选择合适结构、申请 TFN 并取得 ABN。ABN 是您在 ATO 及商业环境中的 11 位唯一标识。在澳大利亚,不管你是想开网店、做自由职业还是成立公司,基本都绕不开ABN(Australian Business Number)——这是一个11位数字的唯一编号,用来在ATO以及其他企业打交道时证明你的身份,没有它,你很难开具正规发票、注册GST,不少客户和平台也不会跟没有ABN的对象合作。申请ABN本身完全免费,直接通过官方的Australian Business Register(business.gov.au / abr.gov.au)在线提交即可,不需要花钱找第三方代办网站;但动手申请之前,你需要先想清楚自己要用哪种经营结构——个体经营(Sole Trader)、合伙(Partnership)、公司(Company)还是信托(Trust),因为结构不同,接下来要填的信息、是否需要单独申请TFN(税号)也会不一样。如果你是澳洲居民个人,已经有TFN,身份信息又能通过myID(原myGovID)在线核实,大多数情况下系统会当场自动批出ABN;但如果材料不完整、系统判定需要人工复核,或者你是新移民、海外人士,又或是刚成立的公司或信托,处理时间可能会拉长到20个工作日左右,这段时间保持邮箱畅通、随时补充材料就很关键。另外值得一提的是,申请ABN时其实可以顺便把GST注册、PAYG预扣税登记以及生意名称(Business Name)一起办掉,省得日后分开跑好几趟——这也是我们建议新客户在做ABN规划时,一次性把整套注册需求理清楚的原因。",
    sections: [
      {
        heading: "ABN 是什么 为什么需要",
        body: "ABN 用于向政府及其他机构识别您的企业。注册 GST、申请能源补助、与其他企业开票交易等都需要 ABN。没有 ABN，付款方可能须从应付款项中预扣 47%。",
      },
      {
        heading: "如何申请 ABN",
        body: "符合条件的个人或实体可通过 ABR 在线申请。前期准备信息十分关键：",
        bullets: [
          "申请人姓名及联系方式",
          "经营地址与邮寄地址",
          "业务结构（Sole Trader、公司、合伙、信托）",
          "经营活动详细描述",
          "相关联实体信息（董事、合伙人、受托人）",
          "身份证明文件",
          "业务开始日期",
        ],
      },
      {
        heading: "谁可以申请",
        body: "ABN 资格按客观标准判断——您必须真实地在澳洲开展或即将开展企业活动：",
        bullets: [
          "在澳洲经营生意",
          "在澳洲进行企业活动（包括职业、行业、专业或一次性商业活动）",
          "在澳洲市场供应商品或服务",
          "在澳大利亚《公司法》下注册成立的公司",
        ],
      },
      {
        heading: "常见的申请被拒原因",
        body: "ABR 可以拒绝或撤销不符合资格的 ABN。常见原因：",
        bullets: [
          "实际为爱好或一次性销售，并非企业",
          "身份信息缺失或不一致",
          "实体尚未正式设立（例如公司未注册）",
          "实质为雇员，申请 ABN 主要为规避 PAYG 预扣",
        ],
      },
      {
        heading: "注册之后",
        body: "拿到 ABN 后还有一系列持续义务，ABS Solutions 全程协助：",
        bullets: [
          "申报所得税（公司或个人，视结构而定）",
          "如已注册 GST，按季度或月度申报 BAS",
          "履行雇员 PAYG 预扣与养老金保障义务",
          "保存企业记录至少 5 年",
          "业务信息变更后 28 天内更新 ABR",
          "停业时及时注销 ABN，避免不必要的申报",
        ],
      },
      {
        heading: "ABS Solutions 如何帮助您",
        body: "我们从第一天起就将 ABN 与正确的企业结构与税务注册一并打包：",
        bullets: [
          "结构建议（Sole Trader、合伙、公司、信托）",
          "ABN、TFN、GST 与 PAYG 一站式注册",
          "信托契约、公司章程与董事 ID 指引",
          "首笔交易即建立簿记与 BAS 流程",
          "中英文双语全程服务",
        ],
      },
    ],
  },

  "company-setup": {
    title: "公司架构设立与商业计划服务 — ABS Solutions",
    metaDescription: "为澳大利亚创业者与成长型企业提供端到端的公司设立与商业计划服务。",
    h1: "公司架构设立与商业计划服务。",
    intro: "从实体注册到财务建模，我们助您构建可持续增长的基础。",
    sections: [
      { heading: "我们提供", list: [
        { heading: "实体注册", body: "Sole Trader、合伙、公司、信托或SMSF——包括ABN、ACN、GST和TFN注册。" },
        { heading: "信托契约与章程", body: "根据您的运营模式与资产保护需求量身定制的文件。" },
        { heading: "商业计划书", body: "清晰阐明价值主张、市场定位与执行方案的战略文档。" },
        { heading: "预算与财务建模", body: "三表合一的财务模型，测试盈利能力，支持贷款申请与决策。" },
        { heading: "咨询服务", body: "在业务扩张中持续提供结构与税务建议。" },
      ]},
    ],
  },

  smsf: {
    title: "自管养老金SMSF服务 — ABS Solutions",
    metaDescription: "ABS Solutions提供SMSF设立、日常会计、年度税务申报与审计协调服务，持牌SMSF顾问助您合规管理退休储蓄，掌握投资主动权。",
    h1: "自管养老金（SMSF）服务。",
    intro: "SMSF 让您直接掌控退休储蓄的投资与管理。我们处理设立、日常会计、税务与审计协调——确保您在专注于长期财富策略的同时保持合规。SMSF(Self Managed Super Fund,自管养老金)最大的卖点就是「自己说了算」——最多可以有6个成员(通常是你和配偶、子女),投资决策完全由你自己(作为受托人)做主,可以直接买卖股票、住宅或商业地产、甚至是收藏品,不用像普通行业基金那样被动接受基金经理的资产配置;但相应的,合规责任也全部落在你身上——每年要完成年度申报(SMSF Annual Return)和独立审计,基金收入通常按15%的优惠税率征税(进入养老金支付阶段则为0%),而且行业普遍认为,除非养老金余额能达到一定规模(业内通常建议20万澳元以上),否则设立与维护SMSF的固定成本(会计、审计、法律)占比太高,反而不如留在大型基金里划算。更值得现在关注的是,针对养老金总余额(TSB)超过300万澳元的个人,Division 296新税已经在2026年3月正式通过国会、并于2026年7月1日起生效——300万至1000万澳元之间的部分,已实现收益要额外多缴15%的税(相当于总税率30%),超过1000万澳元的部分则额外多缴25%(总税率40%);好消息是最终版本已经取消了对未实现资本利得征税的争议条款,只针对已经实现的收益计税,而且300万和1000万两个门槛今后也会按CPI逐年上调。对于持有大额单一资产(比如商业地产)的SMSF成员来说,这项新规会直接影响资产配置和退出时机的规划,我们建议在设立SMSF或调整现有结构之初,就把这些因素一并纳入考虑。",
    sections: [
      {
        heading: "SMSF 适合您吗？",
        body: "SMSF 是一支由您作为受托人运营、最多容纳 6 位成员的私人养老金。它并非人人适合，但在合适的情形下能带来控制权、投资灵活性与显著的税务优惠。",
        bullets: [
          "希望直接控制养老金投资",
          "养老金合并余额足以覆盖运营成本",
          "希望投资多种资产——直接房产、定期存款、上市股票或贵金属",
          "拥有长期退休规划并愿意承担受托人责任",
        ],
      },
      {
        heading: "SMSF 可以投资的资产",
        body: "只要符合投资策略与唯一目的测试（Sole Purpose Test），SMSF 可以持有：",
        bullets: [
          "澳洲与海外上市股票",
          "现金、定期存款与管理基金",
          "直接住宅与商业房产",
          "贵金属与收藏品（须符合严格规定）",
          "有限追索贷款（LRBA）购买的房产",
        ],
      },
      {
        heading: "我们的 SMSF 服务",
        body: "我们涵盖 SMSF 全生命周期——设立、日常管理、年度合规与审计协调——让您专注于策略：",
        list: [
          { heading: "SMSF 设立", body: "信托结构、信托契约、公司受托人创建、ABN/TFN 申请、ATO 注册与银行账户开设。" },
          { heading: "会计与税务", body: "年度财务报表、成员报表、SMSF 税务申报、供款与养老金报告。" },
          { heading: "审计协调", body: "准备审计文件并代您与独立 SMSF 审计师沟通。" },
          { heading: "投资与税务策略", body: "退休阶段规划、供款策略、过渡期结构与税务高效的资产配置。" },
        ],
      },
      {
        heading: "主要税务优势",
        body: "如运作得当，SMSF 在澳大利亚享有十分优惠的税务待遇：",
        bullets: [
          "投资收益享 15% 优惠税率",
          "持有超过 12 个月的资产享 1/3 CGT 折扣（实际 10%）",
          "退休阶段部分资产收益免税（受转账余额上限约束）",
          "灵活的遗产规划与具约束力的死亡受益人指定",
        ],
      },
      {
        heading: "不可忽视的合规义务",
        body: "ATO 是 SMSF 的监管机构，违规可能触发行政处罚甚至基金不合规认定：",
        bullets: [
          "每年审核书面投资策略",
          "唯一目的测试——所有行为必须以退休利益为目的",
          "与关联方交易须按公平原则进行（不得个人使用基金资产）",
          "年度独立审计与 SMSF 申报",
          "受托人教育与签署受托人声明",
        ],
      },
      {
        heading: "ABS Solutions 如何帮助您",
        body: "我们作为您的专业 SMSF 会计师与顾问，把合规复杂性转化为清晰行动：",
        bullets: [
          "端到端 SMSF 设立（含公司受托人与 Bare Trust）",
          "年度合规、成员报表与 ATO 申报",
          "与持牌独立 SMSF 审计师对接",
          "供款、养老金及代际传承的策略建议",
        ],
      },
    ],
  },

  "family-trust": {
    title: "澳洲家庭信托全攻略 | 2028新税解读 — ABS Solutions",
    metaDescription: "家庭信托设立费用、税务规则与每年6月30日前的分配决议要求详解，附2028年7月起30%受托人税新规解读，助您判断现在设立是否仍划算。",
    h1: "澳洲家庭信托全攻略。",
    intro: "家庭信托是澳大利亚常用的结构之一，可用于收入分配、资产保护与长期税务规划。要发挥这些优势，信托必须正确设立并合规管理——本指南将带您了解运作机制、常见用途、税务规则、设立成本与后续义务。如果你正在澳洲考虑用家庭信托(Family Trust / Discretionary Trust)来做收入分配、资产保护或者代际财富传承,现在正好是重新审视这个结构的关键节点——家庭信托一直是澳洲家族企业和个人投资者最常用的架构之一,好处很直接:受托人每年可以根据实际情况,把信托的应税收入灵活分配给边际税率较低的受益人(比如收入较少的配偶或成年子女),从而在合法范围内降低整个家庭的整体税负,同时把个人资产和信托资产隔离开来,起到一定的资产保护作用;但要真正享受到这些好处,信托从一开始就必须设立正确——契约条款、受托人角色的选择,以及每年6月30日前必须完成的分配决议(Trustee Resolution)缺一不可,任何一个环节出错,未妥善分配的收入都可能被ATO按信托最高边际税率(目前为47%)征税。更值得注意的是,2026年5月的联邦预算已经宣布,从2028年7月1日起,家庭信托的应税收入拟在受托人层面被征收30%的最低税——非公司类受益人可以就受托人已缴的税款获得一项不可退还的抵免额,但分配给分红公司(bucket company)受益人的部分将不再享有这项抵免,这会直接影响不少家庭沿用多年的信托+受益公司节税结构;财政部已于2026年9月3日发布了这项立法的草案,其中还包含一项过渡期选择(EET Election),允许在2028年7月1日前已存在的信托,通过向指定受益人做固定比例分配来豁免这项新税,不过目前这仍是尚未通过国会的草案,具体细节后续仍可能调整。正因为规则正处在变化之中,这份指南会带你系统梳理家庭信托的运作机制、常见用途、现行税务规则与即将到来的变化、设立成本,以及每年需要履行的后续合规义务,帮助你判断现在设立或调整信托结构,是否仍然划算。",
    sections: [
      {
        heading: "什么是家庭信托",
        body: "家庭信托是一种由受托人为受益人（通常是家族成员）持有并管理资产的法律结构。其运作由信托契约约定，规定受益人范围及分配方式。澳大利亚的家庭信托多为全权信托，受托人每年自由决定收入与资本如何分配给符合条件的受益人。",
      },
      {
        heading: "家庭信托的常见用途",
        body: "正确使用的家庭信托是澳大利亚税务与财富规划中最灵活的结构之一：",
        list: [
          { heading: "税务规划", body: "在税法允许的范围内，将收入分配至边际税率较低的受益人。" },
          { heading: "资产保护", body: "将信托资产与个人资产分开，降低诉讼、企业失败或债权人风险。" },
          { heading: "家族财富管理", body: "在单一结构中协调长期财富积累与代际传承。" },
          { heading: "投资与商业结构", body: "持有投资物业、股票组合或经营家族企业。" },
        ],
      },
      {
        heading: "税务规则一览",
        body: "理解信托税务框架至关重要。家庭信托本身通常不直接缴纳所得税——收入分配给受益人后由其按个人税率纳税。但需注意：",
        bullets: [
          "未分配收入按最高边际税率（45%）课税",
          "未成年受益人在低门槛以上将面临惩罚性税率",
          "受托人决议必须在每年 6 月 30 日前完成",
          "在特定规则下可对已抵免股息与资本利得进行分配",
          "在享有部分税务优惠前可能需做 Family Trust Election（FTE）",
        ],
      },
      {
        heading: "设立流程",
        body: "正确设立家庭信托需在签署契约前充分规划。标准设立步骤包括：",
        list: [
          { heading: "1. 结构设计", body: "确定个人或公司受托人、受益人范围、Appointor 结构及关联实体。" },
          { heading: "2. 信托契约起草", body: "由法律专业人士根据您的目的与家庭情况起草契约。" },
          { heading: "3. 信托执行", body: "设立人支付结算金、受托人签署，并按需缴纳印花税。" },
          { heading: "4. 税务注册", body: "为信托申请 TFN、ABN 及（如适用）GST，并向州税务局登记土地税。" },
          { heading: "5. 银行与运营账户", body: "开设信托银行账户并更新受益人记录。" },
        ],
      },
      {
        heading: "典型设立费用",
        body: "标准家庭信托设立费用通常为 A$1,200–A$2,000 + GST，包括信托契约、结构咨询、受益人设置、TFN、ABN 注册及相关税务注册。如需公司受托人或 Bare Trust（如 SMSF LRBA 使用），费用另计。",
      },
      {
        heading: "持续合规义务",
        body: "家庭信托是一个需要持续维护的结构：",
        bullets: [
          "每年 6 月 30 日前的受托人年度决议",
          "年度财务报表与信托税务申报",
          "受益人分配声明",
          "如适用，定期审视 Family Trust Election",
          "持有房产的信托需关注各州土地税合规",
        ],
      },
      {
        heading: "ABS Solutions 如何帮助您",
        body: "我们提供端到端的家庭信托支持——从结构咨询到年度申报：",
        bullets: [
          "根据您实际情况量身定制的结构方案",
          "与法律合作伙伴共同起草信托契约",
          "信托设立含 ABN、TFN 及 GST 注册",
          "年度账务、税表及受托人决议起草",
          "中英文双语沟通与家族办公室级别服务",
        ],
      },
    ],
  },

  "negative-gearing": {
    title: "澳洲负扣税2027新规解读 — ABS Solutions",
    metaDescription: "2027年7月起，新购入现房的负扣税规则将改变。了解哪些房产仍可享受负扣税与50%CGT折扣、哪些将受影响，抓紧规划窗口期。",
    h1: "澳洲负扣税全面解析。",
    intro: "负扣税并非税种，而是一种税务概念——指投资资产的可抵扣支出超过其产生的收入，从而形成可抵扣其他收入的账面亏损。如果你正在澳洲考虑买投资房,负扣税这三个字大概率已经在你脑子里转了好几圈——它其实不是什么单独的税种或者优惠政策,而是一个很朴素的会计结果:当一套出租房产每年产生的贷款利息、市政费、维修、折旧、中介管理费这些可抵扣支出,超过它带来的租金收入时,这部分亏损就可以拿去抵扣你的工资或其他应税收入,边际税率越高的人,退税效果往往越明显。不过要提醒一句,这套规则从2027年7月1日起已经不再对所有投资房一视同仁——根据2026年5月12日联邦预算之夜(晚上7点30分AEST)宣布、并已在同年6月获得国会通过和御准的税改法案,凡是在那个时间点之后才签约购入的现房(也就是已建成的二手或存量住宅),其产生的租赁亏损将不能再用来抵扣工资等非租赁收入,只能结转起来,以后拿去抵扣这套房未来的租金收入或出售时的资本利得;而如果你的房产是在2026年5月12日晚7点30分之前就已经持有或签约,又或者你买的是符合条件的全新建成住宅,那么依然可以按照现行规则,继续享受负扣税以及50%资本利得税折扣的双重优惠。也正因为这样,现在这个时间点先把自己名下或计划购入的房产归到老规则还是新规则里,往往比纠结哪个城区更好升值,更能决定你未来几年的税务筹划方向。",
    sections: [
      {
        heading: "负扣税如何运作",
        body:
          "当投资房产的租金收入低于其可抵扣成本（贷款利息、市政费、维修、折旧、中介费）时，所产生的亏损可以抵扣其他应税收入（通常是工资或经营利润）。边际税率越高的投资者受益越显著。",
      },
      {
        heading: "投资者为何使用",
        body: "负扣税是一种长线策略，结合税务效率与资产积累：",
        list: [
          { heading: "减少税负", body: "用房产亏损抵扣日常工资收入——对高边际税率人群最有效。" },
          { heading: "资金效率", body: "使用杠杆参与较大资产并复利增长，无需占用全部现金。" },
          { heading: "长期资本增值", body: "房产通常长期升值。持有阶段不构成应税事件——出售时实现资本利得，个人持有超过 12 个月可享 50% CGT 折扣。" },
          { heading: "更广投资范围", body: "可瞄准增长走廊而非单纯追求收益率，扩展投资选择。" },
        ],
      },
      {
        heading: "亏损如何形成",
        body: "除现金支出（利息、市政费、保险、物业管理、维修）外，税法还允许扣除非现金项目——这些扣减能在无实际现金流出的情况下形成账面亏损：",
        bullets: [
          "Division 43 建筑结构折旧（通常 2.5% pa）",
          "Division 40 家装设备折旧（地毯、窗帘、家电）",
          "贷款开立费用 5 年内分摊",
          "特定情形下的预付利息",
        ],
      },
      {
        heading: "适合人群与不适合人群",
        body: "负扣税同时放大上行与下行。它适合某些投资者，对另一些则风险偏高：",
        bullets: [
          "适合：边际税率高、现金流充裕、长期视角并能承担利率风险",
          "适合：持有多套位置与租金特性分散的物业组合",
          "不太适合：临近退休（工资停止后亏损结转较难利用）",
          "风险：现金流紧绷、缓冲不足——空置或加息可能伤及",
        ],
      },
      {
        heading: "资本利得税（CGT）的考量",
        body: "资本增值是最终回报，但出售时须缴 CGT。关键规划要点：",
        bullets: [
          "以个人身份持有超过 12 个月可享 50% CGT 折扣",
          "尽量在低收入年度出售",
          "未使用的亏损可结转至未来资本利得",
          "由自住转投资时注意主要住所豁免规则",
        ],
      },
      {
        heading: "ABS Solutions 如何帮助您",
        body: "我们为您建模投资房现金流、优化折旧、处理年度申报并预测长期效果：",
        bullets: [
          "购房前的现金流与税务模型",
          "符合 ATO 要求的折旧报告以最大化扣减",
          "投资房年度税务申报与租赁附表",
          "CGT 规划与退出策略建模",
          "中英文双语建议与结构设计",
        ],
      },
    ],
  },

  "home-office-tax": {
    title: "居家办公怎么报税 — ABS Solutions",
    metaDescription: "申报居家办公的合理抵扣。方法、可申报费用与ATO记录要求。",
    h1: "居家办公怎么报税。",
    intro: "在家工作？您可申报部分费用以减少税负——但必须遵守ATO规则并保存良好记录。",
    sections: [
      { heading: "两种可选方法", list: [
        { heading: "固定费率法（每小时）", body: "按ATO公布的固定费率结合工作小时数计算。" },
        { heading: "实际费用法", body: "按实际使用比例计算运营费用。" },
      ]},
      { heading: "专用办公区", body: "如果家中有专门、可识别的工作区域（如独立书房），可按比例申报电费、取暖制冷、清洁、家具折旧与设备维修。ATO可能要求提供照片、平面图与书面说明。" },
      { heading: "常见可抵扣项目", bullets: ["照明、取暖与制冷","办公区域清洁","办公家具与设备折旧","工作相关电话与网络部分","文具、墨盒及工作软件订阅"] },
      { heading: "员工通常不能申报", bullets: ["房租或房贷利息","市政费与房屋保险","咖啡、零食及个人用品","家居装饰与无关装修"] },
    ],
  },

  "business-travel-tax": {
    title: "公务出差费用如何报税 — ABS Solutions",
    metaDescription: "如何申报商务出差的税务抵扣。机票、住宿、餐饮与凭证规则。",
    h1: "公务出差费用如何报税。",
    intro: "因业务需要出差？许多费用可抵扣——但仅当出行确为业务目的且妥善记录时。",
    sections: [
      { heading: "通常可申报", bullets: ["机票、火车、出租车、网约车与租车","出差期间的住宿","过夜差旅期间的合理餐饮","会议与活动注册费"] },
      { heading: "不可申报", bullets: ["混合用途行程中的私人休闲费用","同伴/配偶旅行费用","家与常规工作地点之间的日常通勤"] },
      { heading: "必须保存的记录", bullets: ["超过6晚行程的差旅日志","住宿、交通与餐饮的发票","与工作相关的证明文件"] },
    ],
  },

  // ============================================================
  // 博客文章 / 深度洞察
  // ============================================================

  "sole-trader-vs-company": {
    title: "澳洲做生意选择个人还是公司 — 哪种结构最适合您 | ABS Solutions",
    metaDescription: "澳洲个体经营 vs Pty Ltd 公司——税率、责任、设立成本、合规要求与适合的企业阶段，权威对比解析。",
    h1: "澳洲做生意选择个人还是公司？两种结构全方位对比。",
    intro: "在澳洲创业，最早需要做的重大决定之一就是：以个体经营（Sole Trader）还是以 Pty Ltd 公司形式经营？正确的结构选择会直接影响您的税务负担、个人责任风险、运营成本及未来融资能力。本文为您系统对比两者的优劣势。",
    sections: [
      {
        heading: "两种结构概览",
        body: "个体经营是最简单的结构——您以个人 TFN 加 ABN 经营，所有利润归您、所有亏损也由您承担。Pty Ltd 公司则是经 ASIC 注册的独立法人，按公司税率（基础税率实体 25%，其他 30%）纳税，股东仅以认缴股本为限承担有限责任。",
        bullets: [
          "个体经营 — 按个人边际税率计税（最高 45% + Medicare 税），设立成本极低，个人无限责任",
          "Pty Ltd 公司 — 公司税固定为 25% 或 30%，需 ASIC 合规，独立法人，股东承担有限责任",
          "信托与合伙是其他选择，但不在本文讨论范围",
        ],
      },
      {
        heading: "何时适合选择个体经营",
        body: "个体经营适合初创期、单人经营、利润适度、风险较低且资产较少的业主。设立成本几乎为零（仅需注册 ABN），报税简单（一份税表），税后利润 100% 归您。代价是承担无限个人责任——每一笔企业债务都视同您个人债务，且当利润超过约 10 万澳元后，个人边际税率开始迅速拉高。",
      },
      {
        heading: "为何成长型企业纷纷转为 Pty Ltd",
        bullets: [
          "税率优势：公司税基础税率 25%，远低于个人最高边际税率 47%",
          "资产保护：股东通常仅以未缴股本为限承担责任，公司债务不波及个人资产",
          "信誉提升：供应商、银行及大型客户更愿意与公司打交道",
          "收入灵活：董事可领取工资、股息或两者结合，规划空间更大",
          "融资便利：公司可发行股份吸引投资者，个体经营无法做到",
        ],
      },
      {
        heading: "真实税务对比",
        list: [
          { heading: "年利润 8 万澳元", body: "个体经营税约 16,467 澳元（边际税率）。Pty Ltd 公司税为 20,000 澳元（25%），但留存利润可继续以 25% 税率再投资——这是个体经营无法做到的。" },
          { heading: "年利润 15 万澳元", body: "个体经营税约 40,067 澳元。Pty Ltd 公司税为 37,500 澳元。利润超过约 13.5 万澳元后，公司结构开始占优。" },
          { heading: "年利润 30 万澳元", body: "个体经营税约 103,667 澳元（47% 最高边际税率）。Pty Ltd 公司税为 75,000 澳元，每年节税近 29,000 澳元。" },
        ],
      },
      {
        heading: "经营 Pty Ltd 的隐性成本",
        bullets: [
          "ASIC 年度审查费（2025–26 年度专属公司为 321 澳元）",
          "年度公司报税、财务报表及簿记",
          "董事 ID 注册与《公司法》下持续的董事义务",
          "雇佣员工时的工伤保险（规则与个体经营不同）",
          "董事向公司借款引发的 Division 7A 复杂规则",
        ],
      },
      {
        heading: "ABS Solutions 的 5 步决策清单",
        list: [
          { heading: "1. 预期利润是多少？", body: "低于约 8 万 → 通常个体经营更优。高于约 13.5 万 → 公司开始占优。" },
          { heading: "2. 您所处行业风险有多高？", body: "建筑、餐饮、咨询等责任高的行业 → 公司结构可保护个人资产。" },
          { heading: "3. 利润是再投资还是用于生活？", body: "再投资 → 选公司。全部提取生活 → 个体经营更简单。" },
          { heading: "4. 是否会引入合伙人或投资者？", body: "如有 → 必选公司，个体经营无法发行股份。" },
          { heading: "5. 长期退出规划如何？", body: "出售公司股权结构更清晰、更税务高效，相比直接出售个体业务通常更优。" },
        ],
      },
    ],
  },

  "division-7a-director-loans": {
    title: "Division 7A 全面解析：公司账户的钱，老板可以随便转出来吗？ | ABS Solutions",
    metaDescription: "Division 7A 通俗解读——澳洲 Pty Ltd 公司董事提取现金的合规方式、ATO 视为股息的认定规则、合规借款协议与常见税务陷阱。",
    h1: "Division 7A：公司账户的钱，老板可以随便转出来吗？",
    intro: "许多企业主认为，公司账户里的钱就是自己的——这是个昂贵的误解。澳洲税务局（ATO）通过 1936 年所得税评估法 Division 7A 严防董事与股东将股息伪装成借款。一旦违规，整笔款项将被认定为非抵免股息，按董事个人边际税率全额纳税，且无任何 franking credit 可抵扣。",
    sections: [
      {
        heading: "什么是 Division 7A？为什么存在？",
        body: "Division 7A 适用于私有公司，将向股东（及其关联方）的某些付款、借款或债务豁免视为「视同股息」。目的在于防止企业主将利润累积在按 25% 税率纳税的公司中，再悄悄抽取现金而不缴纳个人税。若提取金额不属于正式工资、合规分红或合规 Div 7A 借款，ATO 即视其为视同股息。",
        bullets: [
          "仅适用于私有（Pty Ltd）公司",
          "涵盖向股东或关联方的付款、借款与债务豁免",
          "按每个纳税年度审查——单笔交易即可触发",
          "处罚：全额按董事个人非抵免股息收入计税",
        ],
      },
      {
        heading: "为什么董事经常掉进 Division 7A 陷阱",
        body: "多数情况并非故意逃税，而是文书缺失。比如：董事从公司取 30,000 澳元装修厨房，准备日后归还，却未签署书面借款协议、未做最低年度还款——ATO 即将该 30,000 澳元在当年视为视同股息。按 47% 边际税率，需多缴 14,100 澳元，本可完全避免。",
      },
      {
        heading: "合法提取公司资金的三种方式",
        list: [
          { heading: "1. 工资或董事费", body: "通过工资单发放，预扣 PAYG、缴纳养老金。公司可抵扣，董事全额纳税——最干净的方式。" },
          { heading: "2. 已抵免股息", body: "从公司税后留存利润中分红。董事获得与已缴公司税相当的 franking credit，避免双重征税。" },
          { heading: "3. 合规的 Division 7A 借款", body: "签署书面协议，按 ATO 基准利率（2025–26 年度为 8.77%），最长 7 年（无担保）或 25 年（房产担保），每年最低还款。" },
        ],
      },
      {
        heading: "合规 Division 7A 借款必须满足",
        bullets: [
          "在公司报税申报前签署书面借款协议",
          "利率不低于 ATO 年度基准利率",
          "固定最长期限——无担保 7 年，房产担保 25 年",
          "按 ATO 公式计算的最低年度还款额",
          "还款不得由同一公司的新借款提供资金",
        ],
      },
      {
        heading: "ABS Solutions 每年遇到的常见错误",
        bullets: [
          "公司信用卡支付私人 Uber Eats、信用卡账单且从未归还",
          "用公司资金支付董事个人装修、子女学费",
          "向董事配偶、父母或家族信托借款（关联方——Div 7A 同样适用）",
          "最低年度还款额哪怕少 1 澳元——差额部分仍视为视同股息",
          "豁免现有董事借款——豁免金额全额视为视同股息",
        ],
      },
      {
        heading: "如何远离 Division 7A 风险",
        list: [
          { heading: "公私账目严格分离", body: "为自己发放固定工资或董事费，切勿从公司账户取钱用于个人生活。" },
          { heading: "年度结束前签署借款协议", body: "若年中确实有提款，必须在 6 月 30 日（或公司申报日期）之前作为 Division 7A 借款签订书面协议。" },
          { heading: "追踪最低年度还款", body: "日历提醒。哪怕少还 5 澳元，差额部分仍触发视同股息。" },
          { heading: "每年与会计师复核", body: "Division 7A 与 FBT、PSI 及分红规则相互作用，小错误可能滚雪球成巨额税务。" },
        ],
      },
    ],
  },

  "cash-flow-management": {
    title: "澳洲小型企业现金流管理完整指南 | ABS Solutions",
    metaDescription: "澳洲小型企业实用现金流管理指南——现金流预测、应收账款管理、付款条款设计、GST 时间差与维持企业偿付能力的关键指标。",
    h1: "澳洲小型企业现金流管理实战指南。",
    intro: "利润是理论，现金才是现实。澳洲证券与投资委员会（ASIC）数据显示，无力偿债经营与战略管理失误始终是小企业失败的首要原因——绝大多数都可追溯到现金流盲点。本文为您系统讲解 ABS Solutions 客户使用的一整套现金流管理方法。",
    sections: [
      {
        heading: "利润 ≠ 现金 — 为什么这一点至关重要",
        body: "您的损益表可以显示 20 万澳元的健康利润，与此同时您却在打电话延迟支付房租。原因：损益表在开票时确认收入，而非收到款项时；它忽略 GST 时间差、BAS 分期、设备购置及贷款本金还款。现金流管理的本质是理解每一笔现金进出的时间点——而非只看总额。",
        bullets: [
          "分别追踪经营、投资、融资三类现金流",
          "客户付款条款与供应商付款条款匹配",
          "按季度预留 BAS、养老金、PAYG 与税务分期",
          "至少维持 8 周运营成本的现金储备",
        ],
      },
      {
        heading: "13 周滚动现金流预测——最实用的工具",
        body: "忘掉年度预算——第 3 周就已过时。每周更新的 13 周滚动现金流预测能尽早发现问题，让您在与供应商谈判时握有主动权，也让银行愿意提高您的透支额度。我们在 Xero 或简单的电子表格中为各行业客户（餐饮、建筑、电商、专业服务）量身定制此工具。",
      },
      {
        heading: "现金紧张时可用的 5 大杠杆",
        list: [
          { heading: "1. 收紧应收账款", body: "从 30 天改为 14 天付款。提供 2% 提前付款折扣。完工当日即开票，而非月底统一开。" },
          { heading: "2. 与供应商重新协商付款条款", body: "申请 30 或 45 天账期取代货到付款。准时还款的客户大多能拿到。" },
          { heading: "3. 管理 GST 时间差", body: "如有资格，从月度 BAS 改为季度 BAS——每个周期多腾出 30–60 天现金。" },
          { heading: "4. 使用 ATO 分期付款计划", body: "若 BAS 或税款无法一次缴清，ATO 提供最长 24 个月的计息分期，通常比拖欠供应商更划算。" },
          { heading: "5. 推迟非关键资本开支", body: "车辆、装修、设备等暂缓采购，或通过 chattel mortgage 按现金流配置融资。" },
        ],
      },
      {
        heading: "每月必看的现金流 KPI",
        bullets: [
          "应收账款天数——客户平均回款天数（目标：低于 35 天）",
          "应付账款天数——平均向供应商付款天数（目标：30–45 天）",
          "现金转换周期——应收天数 + 库存天数 − 应付天数（越低越好）",
          "经营现金流利润率——经营现金 ÷ 收入（目标：10% 以上）",
          "现金储备月数——现金 ÷ 月度固定成本（目标：2 个月以上）",
        ],
      },
      {
        heading: "常见的现金流误区",
        bullets: [
          "把代收的 BAS GST 当作收入——那是 ATO 的钱，暂存您账户",
          "月中从公司账户补贴个人账户却未做 Division 7A 记录",
          "单一客户应收账款占比超过 25% 却未设信用额度",
          "未单独设立税务与养老金储蓄账户——季度负债总让企业主措手不及",
          "为获得季度大批折扣囤积库存，却忘了现金被锁定 90 天",
        ],
      },
    ],
  },

  "single-touch-payroll-stp": {
    title: "什么是单一触点工资系统（STP）以及它是如何运作的 | ABS Solutions",
    metaDescription: "单一触点工资系统（STP）通俗解析——向 ATO 报告的内容、适用对象、STP Phase 2 变化、常见错误及 ABS Solutions 如何为您合规设置。",
    h1: "什么是单一触点工资系统（STP）？以及它是如何运作的。",
    intro: "只要您在澳洲雇佣任何员工——即使只有一名兼职——就必须使用单一触点工资系统（STP）在每次发薪时向 ATO 报告工资、PAYG 预扣与养老金。本文以通俗易懂的方式讲解 STP 的运作机制、STP Phase 2 带来的变化，以及哪些错误会引发 ATO 跟进。",
    sections: [
      {
        heading: "什么是单一触点工资系统？",
        body: "STP 是一套报告框架，要求雇主在每次发薪时（而非每年一次的工资单）将工资信息发送给 ATO。STP 通过安全 API 从您的工资软件（Xero、MYOB、QuickBooks、KeyPay 等）直接抓取毛工资、预扣税款与养老金义务，并向 ATO 发送一次发薪事件。",
        bullets: [
          "自 2019 年 7 月 1 日起，所有雇主强制使用",
          "替代向员工发放的年度 PAYG 工资单",
          "报告毛工资、津贴、扣减、PAYG 预扣与养老金",
          "员工通过 myGov 查看年度至今的工资信息，不再使用纸质工资单",
        ],
      },
      {
        heading: "ATO 为什么引入 STP",
        body: "在 STP 出现之前，ATO 只能在年度结束时获取工资数据——往往为时已晚，无法及时发现拖欠养老金、低额预扣或假承包工现象。STP 让 ATO 获得实时数据，可以提醒拖欠养老金的雇主，并在每年 7 月 1 日用可靠的收入数据预填员工税表。",
      },
      {
        heading: "STP Phase 2 — 2022 年的变化",
        bullets: [
          "毛收入分项报告——奖金、佣金、津贴、加班、休假分别报告",
          "雇佣类型——全职、兼职、临时工、劳务派遣明确报告",
          "工作度假者的国家代码",
          "员工离职原因（辞职、解雇、裁员等）",
          "一次性付款类型细分（E、W、A、B、D 与补发）",
        ],
      },
      {
        heading: "ABS Solutions 为客户修正的常见 STP 错误",
        list: [
          { heading: "员工分类错误", body: "临时工被报为兼职，或外包工被报为员工——扭曲了养老金与 PAYG 计算。" },
          { heading: "漏检 Super Stapling", body: "自 2021 年 11 月起，雇主必须在将新员工默认进入公司养老金基金前，先向 ATO 查询其绑定的养老金基金。" },
          { heading: "Pay category 未映射到 STP Phase 2", body: "津贴误报为毛工资而非每公里津贴——引发 ATO 问询函。" },
          { heading: "年终汇总申报漏报", body: "STP 年终汇总申报必须在 7 月 14 日前完成——否则员工无法干净地报税。" },
        ],
      },
      {
        heading: "ABS Solutions 如何为您正确设置 STP",
        bullets: [
          "审核或配置 Xero/MYOB/QuickBooks 以符合 STP Phase 2",
          "将每一个 pay category 映射到正确的 ATO 收入类型",
          "通过清算中心设置符合 SuperStream 的养老金支付",
          "在 7 月 14 日前完成年终 STP 汇总申报",
          "代表您处理 ATO 关于 STP 错误的所有通知",
        ],
      },
    ],
  },

  "hospitality-tax-deductions": {
    title: "澳洲餐饮从业者报税抵扣完整指南 | ABS Solutions",
    metaDescription: "澳洲厨师、咖啡师、服务员、酒保等餐饮从业者税务抵扣完整指南——制服、培训、工具、刀具、差旅与 ATO 合规要求。",
    h1: "澳洲餐饮从业者报税抵扣完整指南。",
    intro: "餐饮业是澳洲税务申报最活跃的行业之一——厨师、咖啡师、服务员、酒保、厨房助手和酒店员工都可申报大量工作相关扣减，每年可退回数百乃至数千澳元。但 ATO 也将该行业列为重点稽核对象。本文为您系统讲解：哪些可扣减、哪些不可、需要保存哪些凭证。在澳洲的餐饮行业打工——不管你是厨师、咖啡师、服务员、酒保还是厨房帮工——每年报税时其实有不少工作相关支出可以合法抵扣,像是厨师刀具、防滑鞋、制服清洗费,还有跨店工作时自己开车产生的费用,加起来一年退回几百甚至上千澳元都很常见;但也正因为这个行业的抵扣项目多、现金交易频繁,ATO这几年一直把餐饮和酒店服务业列为重点稽核对象之一,系统会自动比对你申报的抵扣金额和同行业、同收入水平的其他纳税人,数字明显偏高就容易被要求提供凭证甚至触发人工审核。具体来说,单笔支出低于300澳元、且能提供合理依据的工作用品(比如一把新买的厨师刀)可以当年立即全额抵扣、不需要保留发票;工作服清洗费如果全年不超过150澳元,也可以不用逐笔留存收据,但你仍然要能大致说清楚这个数字是怎么算出来的;如果你需要自己开车往返不同门店、或者运送笨重的厨具去参加培训,可以用「每公里抵扣法」,按2026–27财年最新的每公里91澳分计算,最多可以按5000公里计入,也就是单车每年最高能抵扣4,550澳元。本文接下来会按具体职位(厨师、咖啡师、服务员、酒保等)逐一列出哪些支出可以报、哪些不可以报,以及每一项分别需要保留什么凭证,帮你在合规的前提下,把该拿回来的退税一分不少地拿回来。",
    sections: [
      {
        heading: "黄金法则——ATO 三步骤扣减判定",
        body: "在申报任何扣减前，每笔支出必须同时满足三个条件：(1) 您自行支付且未获雇主报销；(2) 支出与赚取收入直接相关；(3) 您持有书面记录以证明。任何一项不符，扣减即被否决——且 ATO 可追溯 4 年并加收利息。",
        bullets: [
          "亲自支付且未获雇主报销",
          "与赚取餐饮收入直接相关",
          "保留书面记录——发票、行车日志、日记",
          "按公私使用比例分摊（如 80% 工作 / 20% 私人）",
        ],
      },
      {
        heading: "餐饮从业者可申报的项目",
        body: "以下扣减是 ATO 对餐饮岗位最常认可的项目。每件超过 10 澳元或全年同类金额超过 200 澳元时，请务必保留税务发票或收据——稽核时如无凭证，ATO 一律否决。",
      },
      {
        heading: "设备、工具与制服",
        list: [
          { heading: "厨师刀具与厨房工具", body: "厨刀、切片机、刨皮刀、温度计——单件低于 300 澳元当年全额扣减，高于 300 澳元按使用寿命折旧。" },
          { heading: "有雇主标志的制服", body: "带 logo 的厨师服、围裙、polo 衫与裤子——全额扣减，清洗费用也可扣减。" },
          { heading: "防滑工作鞋", body: "强制性或防护鞋（钢头、防滑）可扣减；普通工作鞋不可。" },
          { heading: "酒水侍酒师与咖啡师资格证", body: "RSA、RSG、咖啡培训、侍酒师考试——与当前岗位相关时可扣减。" },
          { heading: "刀具维护与保养", body: "刀具研磨费、刀卷、刀套——可扣减。" },
        ],
      },
      {
        heading: "培训、证书与工会",
        list: [
          { heading: "强制性证书", body: "RSA、RSG、食品操作员证书、过敏原课程续期——全额扣减。" },
          { heading: "自我提升教育", body: "商业烹饪 Cert III/IV、餐饮管理文凭——与现职直接相关时可扣减（不可申报未来职位）。" },
          { heading: "行业杂志与在线订阅", body: "Hospitality Magazine、Good Food Guide 订阅——按工作相关比例分摊。" },
          { heading: "工会会费与会员费", body: "United Workers Union、AHIA 会费——全额扣减。" },
        ],
      },
      {
        heading: "差旅、餐饮与其他费用",
        list: [
          { heading: "工作地点之间交通", body: "若一天内在两份餐饮工作之间往返，路费可扣减（家与工作地点之间通勤不可）。" },
          { heading: "过夜出差", body: "被派往州际宴会或活动，住宿与餐饮可扣减——超过 6 晚需保留差旅日志。" },
          { heading: "工作相关手机费用", body: "按工作相关比例分摊手机账单（换班、供应商电话、客户订位）。" },
          { heading: "税务代理费用", body: "支付当年 100% 扣减——包括 ABS Solutions 准备此份报税的费用。" },
        ],
      },
      {
        heading: "餐饮从业者不可扣减的项目",
        bullets: [
          "无雇主标志的普通黑色工作鞋或日常服装",
          "理发、化妆或个人形象——即使排班要求",
          "正常班次期间消耗的餐食（无论是否食用）",
          "家与常规工作地点之间的通勤",
          "私人支付的品尝活动饮品",
          "工作期间的儿童看护费用",
        ],
      },
    ],
  },

  "tpar-taxable-payments": {
    title: "什么是应纳税额年度申报表（TPAR）| ABS Solutions",
    metaDescription: "TPAR 全解析——哪些企业必须申报应纳税额年度申报表、需要包含哪些承包商、申报截止日期、罚款及 ABS Solutions 如何为您准备。",
    h1: "什么是应纳税额年度申报表（TPAR）？",
    intro: "若您在以下行业向承包商付款——建筑施工、清洁、快递与道路货运、IT、安保或调查、政府部门工作——ATO 要求您每年提交应纳税额年度申报表（TPAR）。TPAR 独立于 BAS 与公司报税，每年 8 月 28 日截止，迟交将自动产生罚款，每 28 天最高 313 澳元。",
    sections: [
      {
        heading: "TPAR 为什么存在？",
        body: "TPAR 旨在打击现金交易承包工与承包商收入低报。ATO 利用 TPAR 数据交叉核对承包商是否如实申报了客户已支付的收入。历史上现金经济活动较高的行业被纳入强制申报范围，并随项目扩展每年新增行业。",
        bullets: [
          "建筑与施工（自 2012 年起）",
          "清洁服务（自 2018 年起）",
          "快递服务（自 2018 年起）",
          "道路货运服务（自 2019 年起）",
          "IT 服务（自 2019 年起）",
          "安保、调查或监控服务（自 2019 年起）",
        ],
      },
      {
        heading: "谁需要提交 TPAR？",
        body: "若您的企业收入中有 10% 或以上来自 TPAR 涵盖行业，且您在该财政年度向承包商付过款，就必须申报。政府机构对所有承包商付款均需申报，不受 10% 规则限制。个体经营、合伙、信托与公司均在范围内。",
      },
      {
        heading: "TPAR 需要包含哪些信息？",
        bullets: [
          "承包商的 ABN、姓名与营业地址",
          "该财政年度向该承包商支付的总额（含 GST）",
          "上述付款中包含的 GST 总额",
          "每位承包商单独列示——不可合并",
          "不在范围内：员工工资（由 STP 涵盖）、纯材料付款、含 GST 不足 75 澳元的付款",
        ],
      },
      {
        heading: "截止日期与罚款",
        list: [
          { heading: "年度截止日期", body: "财政年度结束后的 8 月 28 日（如 FY2025–26 的 TPAR 于 2026 年 8 月 28 日前提交）。" },
          { heading: "逾期提交罚款", body: "从 313 澳元（小型实体）至 1,565 澳元（大型实体）不等，每 28 天累加一次，最多 5 次。" },
          { heading: "未提交零申报", body: "若您在 TPAR 行业内但未付承包商，仍须提交 Non-Lodgment Advice（NLA）——沉默视同迟交。" },
          { heading: "TPAR 数据不准确", body: "若承包商 ABN 无效或缺失，ATO 可在公司报税时否决相应扣减。" },
        ],
      },
      {
        heading: "ABS Solutions 如何为您准备 TPAR",
        bullets: [
          "通过 Xero/MYOB/QuickBooks 应付账款报表识别全年所有承包商",
          "在 Australian Business Register 验证每一个 ABN",
          "标记缺失 ABN 的承包商——按 47% 无 ABN 预扣率处理",
          "将承包商总额与总账及 BAS 申报数据进行对账",
          "通过 ATO Online Services for Agents 在线提交 TPAR",
          "应要求向承包商出具 Recipient-Created Tax Invoice（RCTI）汇总",
        ],
      },
    ],
  },

  "car-personal-or-company": {
    title: "澳洲买车放在私人还是公司名下？— 完整对比指南 | ABS Solutions",
    metaDescription: "澳洲购车以个人 vs 公司名义对比——税务扣减、FBT、GST、折旧及哪种方式更省。含真实案例分析。",
    h1: "澳洲买车放在私人还是公司名下？",
    intro: "这是澳洲企业主向我们咨询最多的问题之一：这辆车应该用个人名义买，还是放在公司名下？答案取决于使用模式、企业架构，以及您是否愿意承担 Fringe Benefits Tax（FBT）。本文以真实数字为您系统对比两种方案。这是澳洲企业主向我们咨询最多的问题之一:这辆车到底该用个人名义买,还是放在公司名下?这个问题其实没有放之四海而皆准的标准答案,取决于你的用车模式、公司架构,以及你愿不愿意承担FBT(Fringe Benefits Tax,附加福利税)。简单说,如果车辆登记在公司名下,又给员工(包括老板自己作为受薪员工)私人使用,ATO默认这属于一项附加福利,公司就要按47%的税率缴FBT,计算方式通常有两种:一是法定比例法(Statutory Formula Method),不管实际业务用车比例多少,一律按车辆购置价(含GST和经销商交付费,不含注册与印花税)的20%作为应税价值,操作简单但对私用比例低的车来说往往不划算;二是实际成本法(Operating Cost Method),需要连续记满12周的行车日志(有效期5年),按私人使用比例乘以实际运营成本(含视同折旧和视同利息,本FBT年度基准利率为8.27%)计算,业务用车比例超过50%时通常更省税。如果你考虑的是纯电动车(BEV)或氢燃料电池车,现在(截至2027年3月31日的本个FBT年度)只要车辆售价低于91,661澳元的节能车豪华车税起征点、从未被征收过豪华车税、并在2022年7月1日或之后首次投入使用,私人使用部分可以完全免征FBT;但这项优惠已经确定要从2027年4月1日起分阶段收紧——售价超过7.5万澳元的电动车届时只能拿到25%折扣而非全免,插电混动车更是早在2025年4月1日就已经失去了新安排的免税资格,如果你正打算给公司添置电动车,这个时间窗口值得纳入考虑。本文接下来会用真实数字,系统对比私人名下买车与公司名下买车这两种方案,分别在不同用车场景下到底哪个更划算。",
    sections: [
      {
        heading: "核心权衡",
        body: "以个人名义购买，税务简单——按工作相关公里数（cents-per-km）或按行车日志比例扣减运营费用。通过公司购买，可申请 GST 抵免、即时核销，运营费用 100% 可抵扣，但会因任何私人用途引发 FBT。FBT 成本是否超过税务收益，取决于使用方式。",
        bullets: [
          "个人名下：仅可申报工作用途；无 GST 抵免；无 FBT 风险",
          "公司名下：100% 抵扣运营费用；购车价 GST 抵免（受车辆限额约束）；私人用途产生 FBT",
          "混合方案：通过 novated lease 工资打包，平衡抵扣与 FBT 豁免规则",
        ],
      },
      {
        heading: "以个人名义购买——简单选项",
        body: "若全年工作相关行驶不足 5,000 公里，且车辆主要用于私人，个人名义购买几乎总是最佳选择。无需行车日志即可按 FY2025–26 标准 88 分/公里申报，最多 5,000 公里。超过 5,000 公里时改用行车日志法，按业务用途比例申报燃油、注册费、保险、保养与折旧。",
      },
      {
        heading: "通过公司购买——何时占优",
        list: [
          { heading: "GST 抵免", body: "公司可在车辆价格 GST 部分申请抵免，最高至豪华车税限额（FY2025–26 为 69,674 澳元）。" },
          { heading: "即时资产核销", body: "符合条件的小企业实体可对低于 20,000 澳元的车辆当年全额核销（项目可能逐年调整）。" },
          { heading: "折旧上限", body: "高于 LCT 限额（FY2025–26 节能车辆为 91,387 澳元）的车辆，折旧上限为该限额，超出部分不可扣减。" },
          { heading: "100% 运营费用扣减", body: "燃油、注册费、保险、保养、轮胎、停车——全部可扣减（私人用途须按 FBT 调整）。" },
          { heading: "车贷利息抵扣", body: "若车辆登记在公司资产负债表且用于业务，利息可全额扣减。" },
        ],
      },
      {
        heading: "Fringe Benefits Tax — 房间里的大象",
        body: "若公司名下车辆可供员工或董事私人使用，即需缴纳 FBT。FBT 按最高边际税率 47% 计算，若私人使用比例较高，可能完全抵消公司所有权带来的税务好处。",
        bullets: [
          "法定方法——20% × 车辆价 × 可用天数 × (1 − 业务使用比例)",
          "运营成本方法——运营费用 × (1 − 业务使用比例)——对业务用途较高时更划算",
          "FBT 豁免电动车——零 FBT 至 2027 年 4 月 1 日（视法律是否延期）",
          "共用车辆豁免——若车辆确为共享、未分配给单一个人",
          "工作相关车辆——载重小于 1 吨且仅有少量私人用途的 ute/van 可豁免",
        ],
      },
      {
        heading: "案例：60,000 澳元 SUV，业务用途 70%",
        list: [
          { heading: "个人——行车日志法", body: "运营费用 14,000 × 70% = 9,800 澳元扣减。47% 边际税率节税 4,606 澳元。无 FBT。" },
          { heading: "公司——法定方法", body: "扣减 14,000 + 折旧 9,818 = 23,818 × 25% 公司税 = 节税 5,955 澳元。但 30% 私人用途 FBT = 3,628 澳元。净节税 = 2,327 澳元。" },
          { heading: "公司——运营成本方法", body: "扣减不变 23,818 澳元，但按实际 30% 私人用途计算 FBT = 1,974 澳元。净节税 = 3,981 澳元。" },
          { heading: "结论", body: "以业务用途为主（70% 以上）时，公司名下 + 运营成本 FBT 法通常占优；私人用途为主（低于 50%）时，个人名义更划算。" },
        ],
      },
      {
        heading: "特别说明：电动车",
        body: "自 2022 年 7 月 1 日起，低于节能车辆 LCT 限额（FY2025–26 为 91,387 澳元）的零或低排放车辆可享 FBT 豁免——即公司可向员工提供电动车供全私人使用，无任何 FBT 负担。配合 GST 抵免与加速折旧，是目前最具税务效率的购车策略之一——但该 FBT 豁免立法将于 2027 年 4 月 1 日终止，除非届时延期。",
      },
    ],
  },

  "payday-super": {
    title: "Payday Super 澳洲 2026｜雇主必看合规指南 - ABS Solutions",
    metaDescription:
      "Payday Super 已于 2026 年 7 月 1 日正式生效。7 个工作日到账规则、SGC 罚款、STP 新申报要求、现金流应对——墨尔本本地会计事务所为您梳理清楚。",
    h1: "Payday Super 已正式实施：澳洲雇主现在必须做的几件事。",
    intro:
      "如果您的公司有员工、要发工资，那这半年多来您大概率已经听身边不少老板提过 “Payday Super” 这个词。现在它已经不是“即将实施”，而是从 2026 年 7 月 1 日起正式落地的法律要求。如果您的企业还没调整好，现在就是补课的时候。我们是位于墨尔本 Canterbury 的一家本地会计事务所，这几个月几乎每一位有雇员的客户都问过我们类似的问题：“是不是每次发工资都要交养老金？”、“我系统里点了『已支付』算不算合规？” 这些问题背后的细节其实很关键，今天就把它讲清楚。",
    sections: [
      {
        heading: "Payday Super 到底改变了什么？",
        body:
          "很多人第一反应是“是不是要多交钱了”——不是的。养老金保障金（Super Guarantee，SG）比例仍然是 12%，需要缴纳养老金的员工范围也没有变化。真正改变的是支付的时间节奏。以前的规则下，企业可以按季度缴纳，每个季度结束后有 28 天的宽限期。而从 2026 年 7 月 1 日起，养老金必须跟着每一次发薪同步安排，并且要在发薪日起 7 个工作日内，真正到达员工的养老金账户——不是“已发起支付”，而是资金实际被养老金基金收到。这个区别，恰恰是最多老板容易忽略的地方。",
        bullets: [
          "SG 比例仍为 12%——金额没变，是节奏变了",
          "季度缴纳制度已终结，替换为随薪同步缴纳",
          "养老金必须在发薪日起 7 个工作日内实际到账员工基金",
          "「已处理」不等于「已到账」——责任始终在雇主",
        ],
      },
      {
        heading: "「7 个工作日」具体指什么？这是最容易踩坑的点",
        body:
          "很多雇主以为，只要在 payroll 系统里 7 天内点了“付款”就算完成义务，这个理解是不准确的。按照新规，7 个工作日内养老金基金必须实际收到款项，并且拥有足够的信息可以将其分配到员工账户，义务才算完成。如果您走的支付通道处理速度慢，或者员工的养老金基金信息不完整、有误，7 天的时限并不会因此顺延——按时到账仍然是雇主的法定责任。有两类情况可以适用更长的时限：新入职员工在首次发薪后，雇主有 20 个工作日的时间去完成 super fund 的选择和首次供款设置。除了上述例外情况，7 个工作日是标准要求，无论是周薪、双周薪还是月薪都适用。",
      },
      {
        heading: "STP 申报也变了，不只是支付时间变了",
        body:
          "很多人以为 Payday Super 只是把季度缴纳改成随薪同步缴纳，其实 STP（Single Touch Payroll）申报的内容也同步发生了变化。从 2026 年 7 月 1 日起，每一次 STP 申报都需要包含每位符合条件员工的下列字段。QE 决定了该发薪日对应的最低 SG 义务。值得注意的是，一旦某位员工的年度 YTD QE 达到年度供款封顶基数（Maximum Contribution Base，2026–27 财年为 $270,830），本财年剩余时间通常无需再为该员工的后续 QE 支付最低 SG——但 Super Liability 有可能还包含 award 或企业协议下的额外供款义务，这两个数字不能简单划等号。",
        bullets: [
          "年初至今的合格收入（Qualifying Earnings, QE）——一个新概念，已在 Payday Super 申报中取代此前的 OTE（Ordinary Time Earnings）",
          "年初至今的养老金负债（Superannuation Liability）",
        ],
      },
      {
        heading: "小微企业清算所（SBSCH）已经关闭",
        body:
          "如果您企业之前一直依赖 ATO 的小微企业养老金清算所（Small Business Superannuation Clearing House，SBSCH）来处理供款，需要注意：这项服务已于 2026 年 6 月 30 日正式关闭。如果您还没有转到支持 SuperStream 标准、到账速度更快的商业化 payroll / clearing house 方案，这应该是您现在最优先要处理的事情——否则很难稳定做到 7 个工作日到账。",
      },
      {
        heading: "逾期不缴会怎样？",
        body:
          "如果没能按时到账，会触发养老金保证金费用（Superannuation Guarantee Charge，SGC）——处理起来比按时缴纳养老金麻烦得多、成本也更高。SGC 一般包含欠缴的养老金本身、利息，以及行政费用，而且与正常的 SG 供款不同，SGC 通常不能抵税。ATO 已表示，在实施的第一年（2026 年 7 月 1 日至 2027 年 6 月 30 日），对于真正的、轻微的操作失误会采取较为宽容的合规态度，给企业适应新流程的空间。但对于故意或反复不合规的情况——包括根本没有尝试在发薪日缴纳 SG 的雇主——ATO 明确表示会更加严格地对待。由于养老金基金的数据现在会与 STP 申报数据近乎实时地进行比对，迟缴或漏缴比以前更容易被发现。",
      },
      {
        heading: "对大多数企业来说，真正的难点不是合规操作，而是现金流",
        body:
          "我们接触到的客户，一开始几乎都以为 Payday Super 最大的挑战是升级软件系统。但实际操作下来，更难适应的是现金流节奏的改变。在过去按季度缴纳的制度下，很多企业其实是无意中把“应缴未缴”的养老金当作了短期周转资金——这笔钱可以在公司账户里留存长达三个月才需要真正拨出去。这个缓冲空间现在没有了。养老金变成了每个发薪周期都要真金白银流出的成本，节奏和发工资完全同步。如果您所在的行业，从完成工作到收到客户回款之间本来就有较长的时间差（比如人力资源外包、承包类企业感受会特别明显），这个资金缺口现在必须靠公司现有现金来填补，而不能再依赖“晚点交养老金”这种做法。做一份简单的滚动现金流预测表——哪怕只是一个基础版本——都能让您提前发现资金压力，而不是等到该交养老金那一周才发现钱不够。",
      },
      {
        heading: "现在可以做的自查清单",
        bullets: [
          "确认您的 payroll 系统确实支持 Payday Super，并且能通过 STP 正确申报 QE 和 Super Liability",
          "如果还在用 SBSCH，尽快迁移到新的清算所或供款方案，并在正式依赖它之前先测试一遍",
          "核对员工的养老金基金信息——USI、会员编号等信息不完整或有误，是供款被退回或延迟的最常见原因",
          "做一份短期现金流预测，把养老金当作“每次发薪都要出的成本”来规划，而不是季度性支出",
          "和负责 payroll 的同事（或自己）再确认一遍 7 个工作日规则，尤其是“已处理”不等于“已到账”这一点",
        ],
      },
      {
        heading: "需要帮忙确认合规状态？",
        body:
          "如果您不完全确定自己的企业是否已经为 Payday Super 做好准备，或者只是想在 ATO 找上门之前，先请专业人士帮您把 payroll 流程和现金流状况过一遍——欢迎联系我们。ABS Solutions 是一家专注中小企业的墨尔本本地会计事务所，最近几乎每一次和客户的沟通都会聊到 Payday Super 相关的问题。通过联系我们页面留下您的信息，我们会和您一起梳理清楚企业目前的合规状态。",
      },
      {
        heading: "您可能也会感兴趣的延伸阅读",
        list: [
          { heading: "自管养老金 SMSF 服务", body: "如果您也在考虑设立或管理自己的养老金，访问 /zn/smsf 了解更多。" },
          { heading: "澳洲华人会计师事务所 – ABS Solutions", body: "了解我们能为您的企业提供哪些一站式服务，访问 /zn/about。" },
          { heading: "澳洲家庭信托全攻略", body: "家族企业架构与税务规划参考，访问 /zn/insights/family-trust。" },
          { heading: "澳洲负扣税全面解析", body: "投资物业相关的税务规划，访问 /zn/insights/negative-gearing。" },
        ],
      },
      {
        heading: "免责声明",
        body:
          "以上内容仅为一般性信息分享，不构成针对您个人或企业具体情况的税务建议。如需专属方案，欢迎通过联系我们页面与 ABS Solutions 团队进一步沟通。",
      },
    ],
  },
  "business-structure-guide": {
    title: "澳洲企业架构怎么选？个体户/合伙/公司/信托全解析｜ABS Solutions 墨尔本会计师",
    metaDescription:
      "个体户、合伙、公司还是信托？墨尔本 ABS Solutions 华人注册会计师详解四种澳洲企业架构的税务、责任与适用场景，助您选对起点，预约免费咨询。",
    h1: "澳洲企业公司架构怎么选？个体户/合伙/公司/信托全解析",
    intro:
      "很多华人朋友第一次在澳洲创业时，都会被同一个问题卡住：“我到底该注册个体户（Sole Trader）、合伙企业（Partnership）、私人有限公司（Pty Ltd）还是信托（Trust）？” 这个决定看似只是一张 ABN 申请表格上的选项，实际上却牵动着你未来每一年的税务负担、个人资产风险、以及日后融资或出售生意的空间。选错架构，轻则每年多交不必要的税，重则在生意出问题时把自己的房子、存款一并搭进去。",
    youtubeId: "asGKjCKSgTI",
    videoTitle: "视频版讲解：澳洲企业公司架构怎么选？",
    videoCaption:
      "5 分钟看完 ABS Solutions 团队讲解个体户、合伙、公司与信托四种架构的核心差异与选择思路。",
    sections: [
      {
        heading: "四种架构一览",
        body:
          "在这篇文章里，ABS Solutions（澳洲注册会计师，CPA Australia 正式会员）将用最直白的方式，把四种主流架构的税务、责任、适用场景讲清楚。架构选择没有标准答案——最合适的架构，永远是根据您的具体行业、风险承受度和长远目标量身定制的。而且架构一旦跑偏，后续调整（比如把个体户转成公司）往往涉及资产转让、印花税、资本利得税等额外成本，提前规划远比事后补救划算。",
        bullets: [
          "个体户 Sole Trader——最简单的起点，但你和生意在法律上是同一个人",
          "合伙 Partnership——两人以上共同经营，责任仍然是无限连带",
          "公司 Pty Ltd——独立法人，有限责任，税率 25%–30% 稳定可控",
          "信托 Trust——收入分配灵活、资产保护更强，但设立与合规成本较高",
        ],
      },
      {
        heading: "一、个体户 Sole Trader：最简单，但责任无限",
        body:
          "个体户是绝大多数自由职业者、送外卖、留学生副业、小型服务型生意的起点——用你自己的姓名和 TFN 经营，不需要单独注册公司实体。优点是设立成本几乎为零，注册 ABN 即可开始经营；报税相对简单，营业收入并入个人所得税申报；亏损可以直接抵扣你的其他个人收入（在符合非商业性亏损规则的前提下）。缺点也很直接——无限责任：生意的债务等同于你个人的债务，一旦被起诉或欠债，个人房产、存款都可能被追偿；按个人边际税率交税，根据 2026–27 财年税率，超过 $45,000 的部分要缴 30%，超过 $135,000 部分缴 37%，超过 $190,000 部分缴 45%（首 $18,200 免税，$18,201–$45,000 为 15%）；生意越做越大后，个人税率往往比公司税率更高，节税空间有限。适合谁：刚起步、营收不高、风险较低的自由职业、咨询、电商代购、送餐等业务。",
      },
      {
        heading: "二、合伙企业 Partnership：两人以上共同经营",
        body:
          "合伙企业由两个或以上的个人/实体共同出资经营，常见于会计师事务所、律所、诊所等专业服务行业，也常用于华人家庭合伙做餐饮、贸易生意。关键点：合伙企业本身不缴纳所得税，但每年仍需提交合伙企业税表（Partnership Tax Return）；利润或亏损按合伙协议约定的比例分配给每位合伙人，再并入各自的个人报税；责任同样是无限的，而且是“连带责任”——如果一位合伙人惹上债务或法律纠纷，其他合伙人可能也要共同承担。适合谁：有信任基础的家人、朋友或专业伙伴共同创业，且行业风险相对可控的情况。我们建议合伙前一定要有书面的合伙协议，明确出资比例、退出机制与责任分配，避免日后“亲兄弟明算账”的纠纷。",
      },
      {
        heading: "三、私人有限公司 Pty Ltd：有限责任 + 更低税率",
        body:
          "公司是澳洲最常见的商业实体形式之一，受《2001 年公司法》监管，由 ASIC 注册与监督。优点：有限责任——公司是独立法人，一般情况下股东和董事的个人资产与公司债务是分开的（但要注意，若董事有个人担保、或违反《公司法》相关董事责任条款，仍可能承担个人责任）；税率更低且稳定——年营业额不超过 5,000 万澳元、且被动收入（利息、租金、资本利得等）不超过总收入 80% 的“基础税率实体”，公司税率为 25%；其他公司统一按 30% 征收——这通常比个人边际税率（最高 45%）更有优势，尤其是当你计划把利润留在公司内部再投资时；也更容易融资、引入股东、日后出售股权。缺点：设立与维护成本更高，需要每年向 ASIC 缴纳年费、提交公司年报；合规要求更严格——董事职责、公司决议、股东名册等都需要规范管理；从公司提取利润给个人（分红）时，需要注意归集抵免（Franking Credits）机制，避免双重征税或税务规划不当。适合谁：计划长期经营、营收逐步扩大、希望隔离个人资产风险、或未来考虑融资/出售生意的企业主。",
      },
      {
        heading: "四、信托 Trust：灵活分配收入，资产保护更强",
        body:
          "信托本身不是一个“经营实体”，而是一种法律关系——受托人（Trustee，可以是个人或公司）代表受益人（Beneficiaries）持有和管理资产/生意。华人家庭常用的是家庭信托（Discretionary/Family Trust）。优点：收入分配灵活——受托人可以根据每年情况，把利润分配给不同的受益人（例如收入较低的家庭成员），从而合法降低整体家庭税负；资产保护——结构设计得当的信托，可以在一定程度上把生意资产与个人风险隔离开；适合家族财富传承、多代人共同持有资产的场景。缺点：设立与维护成本较高，需要专业律师起草信托契约（Trust Deed）；信托本身不缴所得税，但如果当年利润未分配给任何受益人，未分配部分将按最高边际税率 45% 征收——这是很多人容易忽略的“坑”；合规与文件管理复杂，建议交由专业会计师全程跟进。适合谁：有一定资产规模、希望做税务筹划与家族财富保护的家庭或企业主。想深入了解信托的运作细节？欢迎阅读我们的专题文章《澳洲家庭信托全攻略》（/zn/family-trust-guide）。",
      },
      {
        heading: "四种架构一览对比",
        list: [
          { heading: "个体户 Sole Trader", body: "无限责任；个人边际税率，最高 45%；设立成本低——适合起步阶段、自由职业。" },
          { heading: "合伙 Partnership", body: "无限连带责任；按份额并入个人税率；设立成本低-中——适合多人小型合伙生意。" },
          { heading: "公司 Pty Ltd", body: "有限责任；税率 25%–30%；设立成本中-高——适合成长型、有扩张计划的企业。" },
          { heading: "信托 Trust", body: "责任视受托人类型而定；已分配收入按受益人税率，未分配部分 45%；设立成本高——适合税务筹划、资产保护、家族传承。" },
        ],
      },
      {
        heading: "怎么选？先问自己三个问题",
        bullets: [
          "生意的风险有多大？涉及大额合同、雇佣员工、专业责任的行业，优先考虑公司架构隔离个人风险",
          "未来是否有扩张、融资、引入股东的计划？如果有，公司架构更方便股权设计与后续融资",
          "家庭是否需要收入分配与资产保护？如果家庭成员收入差异较大，或希望做长期财富传承，信托值得考虑",
          "很多企业主最终会采用“公司 + 信托”的混合架构，兼顾有限责任与税务灵活性",
          "架构一旦跑偏，后续调整往往涉及印花税与资本利得税——提前规划远比事后补救划算",
        ],
      },
      {
        heading: "ABS Solutions 能帮您做什么？",
        body:
          "ABS Solutions（Absolute Business Services）是一家扎根澳洲超过 11 年的家族经营会计师事务所，团队由 CPA Australia 正式会员组成，精通澳洲税法及 ASIC 监管体系，同时具备零售、制造、科技等多行业实战经验。我们为华人客户提供中文一对一远程会计服务，收费公开透明，事前充分沟通，绝无隐形收费。在企业架构选择上，我们可以帮您：根据行业、营收规模与风险，量身推荐最合适的架构；协助完成 ABN/ACN/GST 注册、公司或信托设立全流程；提供后续的小型企业税务（/zn/small-business-tax）与 BAS 申报（/zn/bas-lodgement）服务，确保合规无忧；如果您已经营多年、想了解现有架构是否还适合企业当前规模，我们也提供架构复核与优化建议。想了解更多关于我们的服务范围，可以访问澳洲华人会计师事务所（/zn/chinese-accountants-australia）或墨尔本会计师事务所（/zn/melbourne-accounting-firm）页面。",
      },
      {
        heading: "延伸阅读",
        list: [
          { heading: "澳洲小型企业税务", body: "个体户与公司的抵扣、即时资产折旧与合规重点，访问 /zn/small-business-tax。" },
          { heading: "BAS 申报服务", body: "让 BAS 与工资 STP 申报同步无误，访问 /zn/bas-lodgement。" },
          { heading: "澳洲家庭信托全攻略", body: "深入了解家庭信托的设立、税务与分配逻辑，访问 /zn/family-trust-guide。" },
          { heading: "公司设立服务", body: "ABN/ACN/GST 注册与公司注册全流程，访问 /zn/company-setup。" },
        ],
      },
      {
        heading: "立即预约免费咨询",
        body:
          "不确定哪种架构最适合您的生意？欢迎联系 ABS Solutions，我们的注册会计师团队会根据您的实际情况给出专业建议。Canterbury 总部（墨尔本）：205 Canterbury Road, Canterbury VIC 3126，电话 +61 3 9826 1316。Brisbane 办公室：Level 19, 10 Eagle Street, Brisbane QLD，电话 +61 7 3087 3404。邮箱 info@abs-solutions.com.au，或通过联系我们页面预约您的专属架构咨询。",
      },
    ],
  },
  "in-house-vs-outsourced-accounting": {
    title: "全职会计 vs 外包会计：澳洲中小企业老板省钱对比指南｜ABS Solutions",
    metaDescription:
      "请全职会计每年要花多少？外包又能省下什么？墨尔本 ABS Solutions 为华人中小企业主拆解全职与外包会计的真实成本与利弊，助您做出最省钱的决定。",
    h1: "全职会计 vs 外包会计：澳洲中小企业老板一定要看的省钱对比",
    intro:
      "生意做到一定规模，几乎每位老板都会遇到同一个纠结：“我该请一个全职会计坐在办公室里，还是把账务外包给专业的会计师事务所？” 这不是一个非黑即白的问题，答案取决于您的生意规模、现金流状况，以及您希望把时间和精力放在哪里。这篇文章，ABS Solutions 从真实成本、专业深度、灵活性和风险四个维度，帮您把这笔账算清楚。",
    youtubeId: "-F_zcY0WZEE",
    videoTitle: "视频版讲解：全职 vs 外包会计的真实成本对比",
    videoCaption:
      "5 分钟看清一个全职会计的“隐形成本”与外包服务的真实价格差异。",
    sections: [
      {
        heading: "老板算成本时最容易忽略的部分",
        body:
          "很多老板在算“请一个会计多少钱”的时候，只看了广告上的年薪数字，却忽略了背后一整套的隐性成本。把这些加总，一名全职会计的实际年度综合成本，往往比表面工资高出不少。而且，无论生意这个月是忙是闲，这笔固定支出都不会减少。外包则反过来——您用一部分全职薪资的成本，换来一整个专业团队的支持。",
        bullets: [
          "基本工资只是全职会计真实年度成本的约 70–75%",
          "12% 强制养老金、年假与法定假日再加 15–20%",
          "招聘、软件、办公场地和管理精力全部要另算",
          "外包按固定或按需计费，成本随实际工作量波动",
        ],
      },
      {
        heading: "一、全职会计到底要花多少钱？",
        body:
          "聘用一名全职会计，通常需要考虑：基本工资——澳洲会计岗位的薪资区间差异较大，初级会计到有经验的注册会计师，年薪大致在 $6 万至 $9 万澳元不等（具体视经验、地区与行业而定）；11.5%–12% 的强制养老金（Super Guarantee）——根据现行规定，雇主须为员工缴纳 12% 的养老金；年假、病假、法定假日工资——这些“看不见”的成本，通常会再增加实际人力成本的 15–20%；招聘成本——中介费、面试时间、培训上岗周期；办公场地、电脑设备、会计软件订阅（如 Xero、MYOB）License 费用；以及管理精力——一名会计员工也需要老板花时间管理、指导、考核。把这些加总，一名全职会计的实际年度综合成本，往往比表面工资高出不少。",
      },
      {
        heading: "二、外包会计：按需付费，专业团队随时待命",
        body:
          "外包给专业会计师事务所（如 ABS Solutions），本质上是用固定或按需的服务费，换取一整个团队的专业支持，而不是一个人的时间。核心优势包括：成本更透明可控——大多数事务所提供固定套餐或按服务项目收费，您清楚知道每月/每年要花多少，不会有意外的加班费、离职交接成本；专业深度更强——一个人很难同时精通税务筹划、SMSF、审计、BAS 申报、公司架构等所有领域，而事务所背后是一整个团队的专业积累，遇到复杂问题（比如信托分配、跨境税务）也有资深会计师把关；弹性伸缩——生意旺季需要更多支持，淡季可以减少服务频率，不需要背负固定的人力成本；降低合规风险——专业事务所会持续跟进 ATO 政策变化（比如近期的 Payday Super、AML/CTF 新规），及时提醒您企业需要做的调整，避免因为不知情而被罚款；不用担心“人走了怎么办”——全职员工离职、休假，账务可能出现断层，外包团队有制度化的流程，交接更顺畅。局限性也需要认识：外包无法像全职员工一样随时坐在办公室里处理临时事务；如果您的业务量极大、需要每日实时账务处理，可能仍需要内部行政或簿记支持——外包更适合作为税务、合规与战略层面的专业支持。",
        bullets: [
          "月度或按项目定价，成本透明可预测",
          "背后是一整个专业团队，而不是一个人的工作时间",
          "旺季扩容、淡季收缩，不用背固定人力成本",
          "主动跟进 ATO 新规，提前提醒需要做的调整",
          "员工休假或离职都不会造成账务断层",
        ],
      },
      {
        heading: "三、什么情况下更适合全职？什么情况下外包更划算？",
        list: [
          { heading: "初创、微型企业，营收和交易量不大", body: "外包会计几乎总是更划算。" },
          { heading: "需要每天处理大量票据、日常记账", body: "可考虑内部簿记员 + 外包会计师做税务/合规把关。" },
          { heading: "中小型企业，希望控制固定成本", body: "外包会计能把成本与实际业务量挂钩。" },
          { heading: "大型企业，交易复杂度极高", body: "需要专职 CFO/财务团队（甚至内部 + 外部顾问结合）。" },
          { heading: "希望获得 SMSF、信托、审计等专业支持", body: "外包给专业事务所，专业度更深。" },
        ],
      },
      {
        heading: "四、外包会计，选择本地事务所还是海外代账？",
        body:
          "近年也有不少企业选择把简单、重复性的记账工作外包到海外（如印度、菲律宾）以降低成本，但需要留意：海外团队对澳洲本地税法、ATO 最新政策的熟悉程度可能有限，尤其是像信托分配、SMSF 合规这类细节要求高的领域；数据安全与隐私合规也是需要评估的因素；对于需要签署 ATO 文件、代表企业与税局沟通的注册税务代理服务，必须由在澳洲注册的税务代理（Registered Tax Agent）完成。这也是为什么，很多华人企业主更倾向于选择像 ABS Solutions 这样本地注册、中文服务的会计师事务所——既有本地专业资质保障，又没有语言与文化沟通的障碍。",
      },
      {
        heading: "ABS Solutions：您的外包会计团队",
        body:
          "ABS Solutions 是一家经营超过 11 年的家族会计师事务所，团队由 CPA Australia 正式会员组成的注册会计师团队，为华人企业主提供专属会计师一对一远程服务，让您足不出户即可高效管理财税事项。我们的外包服务涵盖：日常记账、BAS 申报（/zn/bas-lodgement）；小型企业税务规划与申报（/zn/small-business-tax）；公司/合伙/信托架构下的税务处理；SMSF 设立与年度合规；阶段性财务顾问与商业咨询。所有服务价格事前充分沟通、公开透明，绝无隐形收费，帮您把每一分钱都花在刀刃上。您也可以留意我们的澳洲税务截止日期指南（/zn/australian-tax-deadlines），避免错过重要申报节点而产生罚款。",
      },
      {
        heading: "延伸阅读",
        list: [
          { heading: "BAS 申报服务", body: "让 BAS 与工资 STP 申报同步无误，访问 /zn/bas-lodgement。" },
          { heading: "澳洲小型企业税务", body: "个体户与公司抵扣与合规重点，访问 /zn/small-business-tax。" },
          { heading: "澳洲税务截止日期", body: "全年报税与 BAS 的重要节点，访问 /zn/australian-tax-deadlines。" },
          { heading: "澳洲企业公司架构怎么选", body: "个体户、合伙、公司或信托对比，访问 /zn/business-structure-sole-trader-partnership-company-trust-australia。" },
        ],
      },
      {
        heading: "算一笔账，从今天开始",
        body:
          "与其在“请人”还是“不请人”之间纠结，不如直接找专业会计师，根据您的实际交易量和业务复杂度，给您一份清晰的成本对比方案。Canterbury 总部（墨尔本）：205 Canterbury Road, Canterbury VIC 3126，电话 +61 3 9826 1316。Brisbane 办公室：Level 19, 10 Eagle Street, Brisbane QLD，电话 +61 7 3087 3404。邮箱 info@abs-solutions.com.au，或通过联系我们页面获取专属您企业的成本对比方案。",
      },
    ],
  },
  "aml-ctf-tranche-2": {
    title: "2026 澳洲 AML/CTF 新规解读：会计师、地产中介必看合规指南｜ABS",
    metaDescription:
      "2026 年 7 月 1 日起，会计师、律师、地产中介等纳入 AUSTRAC 反洗钱监管。墨尔本 ABS Solutions 详解 Tranche 2 合规要求、注册时限与应对方案。",
    h1: "澳洲 AML/CTF 新规解读：会计师、地产中介、律师必看合规指南（2026）",
    intro:
      "2026 年 7 月 1 日，澳洲反洗钱与反恐怖融资监管迎来了近二十年来最大规模的扩张——Tranche 2 改革正式生效。如果您是会计师、律师、地产中介、验证师（Conveyancer）、或从事信托与公司服务（Trust and Company Service Provider），从这一天起，您的行业第一次被纳入澳大利亚交易报告与分析中心（AUSTRAC）的监管范围。对于 ABS Solutions 这样同时提供会计、税务与审计服务（包括为地产中介、验证师、SMSF 信托账户提供审计）的事务所而言，这项改革直接影响我们自己，也直接影响我们大量华人客户的合规义务。",
    youtubeId: "oJRh86okdkE",
    videoTitle: "视频版讲解：澳洲 AML/CTF Tranche 2 新规",
    videoCaption:
      "5 分钟看清谁被纳入监管、要做什么、以及关键的注册时间点。",
    sections: [
      {
        heading: "什么是 Tranche 2？为什么现在才推出？",
        body:
          "澳洲的《反洗钱与反恐怖融资法》（AML/CTF Act 2006）自 2006 年起，一直只监管银行、赌场、汇款服务商等 “Tranche 1” 金融机构。而律师、会计师、地产中介等被国际金融行动特别工作组（FATF）称为“守门人行业”（Gatekeeper Professions）的群体，长期游离在监管之外——澳洲也因此成为经合组织（OECD）中少数几个未对这些行业实施 AML/CTF 监管的国家。2024 年 12 月 10 日，《反洗钱与反恐怖融资修正法案 2024》正式获得御准，将监管范围扩展至以下“指定服务”（Designated Services）提供者，即 Tranche 2 实体。据估算，这次改革将新增约 8 万至 10 万家企业纳入 AUSTRAC 监管体系，是该体系自 2006 年成立以来规模最大的一次扩容。",
        bullets: [
          "律师（Lawyers）",
          "会计师（Accountants）",
          "地产中介（Real Estate Agents）",
          "验证师 / 产权过户代理（Conveyancers）",
          "房地产开发商（Property Developers）",
          "贵金属与宝石交易商",
          "信托与公司服务提供者（Trust and Company Service Providers）",
        ],
      },
      {
        heading: "关键时间节点",
        list: [
          { heading: "2024 年 12 月 10 日", body: "《AML/CTF 修正法案 2024》正式获得御准。" },
          { heading: "2026 年 3 月 31 日", body: "已有的 Tranche 1 报告实体须落实新规则；Tranche 2 实体的 AUSTRAC 注册通道同步开放。" },
          { heading: "2026 年 7 月 1 日", body: "Tranche 2 新规正式生效，新纳入行业须开始履行 AML/CTF 义务。" },
          { heading: "2026 年 7 月 29 日", body: "若您在 7 月 1 日当天已在提供指定服务，须在此日期前完成 AUSTRAC 注册。该日期已过——若您尚未注册，应立即行动，每一笔未合规处理的交易都可能被视为单独一次违规。" },
        ],
      },
      {
        heading: "被纳入监管后，您需要做什么？",
        body:
          "一旦被认定为 AML/CTF 报告实体，核心合规义务通常包括：向 AUSTRAC 注册（Enrolment）——这是所有后续义务的前提；制定书面的 AML/CTF 合规计划（Program），包括风险评估、内部制度与流程；指定合规负责人（AML/CTF Compliance Officer），需为“适格适任”（fit and proper）人选；客户尽职调查（Customer Due Diligence, CDD）——核实客户身份，了解交易目的，识别政治敏感人物（PEP）与制裁名单；持续监控与风险评估，识别异常或可疑交易模式；可疑交易报告（Suspicious Matter Reports, SMR）——发现可疑活动须及时上报 AUSTRAC；记录保存 7 年；员工培训，确保团队理解并能执行合规流程。这里有一个常被误解的关键点：新规监管的是“指定服务”本身，而不是“会计师”这个职业头衔。单纯的报税、日常记账、常规财税咨询，本身并不会自动触发 AML/CTF 义务；但同一位会计师只要涉及协助设立公司或信托、担任受托人、管理属于指定服务范畴的客户资金或资产、协助房地产交易等具体服务，这部分业务就落入监管范围。实务中，很多会计师事务所的业务恰好横跨这两类——逐笔梳理“哪些具体服务属于指定服务”，比笼统判断“我是不是被监管了”更重要。",
        bullets: [
          "AUSTRAC 注册（Enrolment）——所有后续义务的前提",
          "书面 AML/CTF 合规计划：风险评估、内部制度与流程",
          "指定合规负责人（AML/CTF Compliance Officer）",
          "客户尽职调查（CDD）：身份核实、目的了解、PEP 与制裁名单筛查",
          "持续监控与可疑交易报告（SMR）",
          "记录保存 7 年 + 员工制度化培训",
        ],
      },
      {
        heading: "不合规的后果有多严重？",
        body:
          "AUSTRAC 的执法力度不容小觑。根据现行《AML/CTF 法》，针对最严重的违规行为，法院可判处的最高民事罚款为：个人最高 2 万个罚款单位，企业最高 10 万个罚款单位。按照澳洲联邦政府 2026 年生效的罚款单位价值（约 $330/单位）估算，理论上限约为：个人 660 万澳元，企业 3,300 万澳元——当然，这是法院可判处的法定上限，并非每一次违规都会被顶格处罚，AUSTRAC 通常会先以教育、指导为主，但对系统性或恶意违规会毫不手软。此外，“通风报信”（Tipping Off）——即告知客户您已提交或正在考虑提交可疑交易报告——属于刑事犯罪，最高可判处 2 年监禁。AUSTRAC 近年对西太平洋银行（Westpac，13 亿澳元）、Crown 度假村（4.5 亿澳元）、SkyCity 阿德莱德（6,700 万澳元）等大型机构的执法案例，也充分说明了监管机构“来真的”的态度。虽然这些是大型金融机构的案例，但 AUSTRAC 已公开表示：企业规模不是免责的理由，中小型专业服务机构同样在监管视野之内。",
      },
      {
        heading: "对华人企业主与专业人士意味着什么？",
        body:
          "如果您是地产中介或验证师——处理房产交易与信托账户，是这次改革重点关注的对象之一；如果您是会计师或税务代理——协助客户设立公司、信托，或处理商业收购/出售，这部分业务也会被纳入监管；如果您是正在使用会计师、律师、地产中介服务的企业主——虽然直接合规义务在服务提供方，但您也可能需要配合提供更详细的身份与交易信息（比如提供更完整的身份证明文件），这是新规下的正常流程，不必惊慌。对于本身就提供 SMSF、验证师与地产中介信托账户审计服务（/zn/services-and-price）的 ABS Solutions 而言，我们比大多数机构更早关注并落实了这套新规——这也意味着，我们能更专业地协助客户理解新规对其业务的实际影响。",
      },
      {
        heading: "现在应该做什么？",
        bullets: [
          "确认自己是否属于 Tranche 2 实体：只要您提供“指定服务”，基本都在监管范围内",
          "如果尚未注册，立即向 AUSTRAC 提交注册申请",
          "制定并落实书面的 AML/CTF 合规计划，而不是等到被检查才临时补文件",
          "对团队进行培训，确保一线人员理解 CDD 与可疑交易识别的基本要求",
          "建立规范的记录保存机制，满足 7 年留存要求",
          "如果不确定自己的业务是否涉及“指定服务”，建议尽快咨询专业顾问，避免因不了解规则而“被动违规”",
        ],
      },
      {
        heading: "ABS Solutions：与您一起把合规做扎实",
        body:
          "ABS Solutions 作为一家同时提供会计、税务与审计服务（涵盖 SMSF、验证师、地产中介信托账户审计）的专业事务所，我们深知新规对相关行业的实际影响。我们可以协助您：判断您的业务是否构成 AML/CTF “指定服务”；梳理现有客户尽职调查流程，识别合规缺口；协助准备 AUSTRAC 注册与合规计划所需的文件；作为您日常审计与税务合规工作的延伸，帮您把新规要求融入现有工作流程。如果您也在关注公司架构、信托设立等相关话题，欢迎延伸阅读我们的《澳洲家庭信托全攻略》（/zn/family-trust-guide），或了解我们的澳洲华人会计师事务所（/zn/chinese-accountants-australia）整体服务范围。",
      },
      {
        heading: "延伸阅读",
        list: [
          { heading: "澳洲家庭信托全攻略", body: "深入了解家庭信托的设立、税务与分配逻辑，访问 /zn/family-trust-guide。" },
          { heading: "自管养老金 SMSF 服务", body: "SMSF 设立与年度审计合规，访问 /zn/smsf。" },
          { heading: "澳洲华人会计师事务所", body: "中文一对一远程会计与税务服务，访问 /zn/chinese-accountants-australia。" },
          { heading: "服务与价格", body: "会计、税务与审计全套服务清单，访问 /zn/services-and-price。" },
        ],
      },
      {
        heading: "立即联系我们，评估您的合规风险",
        body:
          "新规刚刚生效，越早行动，越能避免后续的合规压力与潜在罚款风险。Canterbury 总部（墨尔本）：205 Canterbury Road, Canterbury VIC 3126，电话 +61 3 9826 1316。Brisbane 办公室：Level 19, 10 Eagle Street, Brisbane QLD，电话 +61 7 3087 3404。邮箱 info@abs-solutions.com.au，或通过联系我们页面评估您的业务在新规下的合规义务。",
      },
    ],
  },
"box-hill-accountant": {
  title: "Box Hill 会计师事务所 — ABS Solutions",
  metaDescription: "Box Hill 会计师 — 服务Box Hill及墨尔本东区华人商圈超过12年。税务申报、簿记、BAS/GST、SMSF——中英双语团队，Canterbury办公室仅5分钟车程。",
  h1: "Box Hill 会计师 — 服务本地华人商圈超过12年。",
  intro: "如果你人在Box Hill,正在找一位真正了解本地华人商圈的会计师事务所,ABS Solutions从2012年起就扎根在Canterbury Road——距离Box Hill Central和Box Hill火车/电车换乘枢纽车程只要5分钟。我们的注册会计师是CPA Australia正式会员,每天都在为Box Hill本地的个人、小生意和物业投资者处理报税、做账,当中不少是本地华人商户与家庭,团队可以用普通话、粤语加英文全程沟通。不管你住在Box Hill、Box Hill South、Box Hill North、Mont Albert还是Surrey Hills,都可以直接来Canterbury办公室面谈,也完全可以线上远程办理,由你自己决定最方便的方式。",
  sections: [
    {
      heading: "为什么Box Hill客户选择ABS Solutions",
      bullets: [
        "距离Box Hill Central及交通枢纽仅5分钟车程",
        "家族式经营,逾12年服务墨尔本东区",
        "CPA Australia会员、注册税务代理及SMSF专项顾问",
        "中英双语服务——普通话、粤语、英文,贴合Box Hill华人商圈需求",
        "可选Canterbury办公室面谈,也可全程线上处理",
      ],
    },
    {
      heading: "我们为Box Hill个人与企业提供的服务",
      list: [
        { heading: "个人与企业报税", body: "为雇员、个体经营、公司、信托及合伙企业准确、合规地准备并提交税表。" },
        { heading: "簿记与BAS/GST", body: "为Box Hill的零售商、餐饮及专业服务企业提供Xero、MYOB、QuickBooks做账及季度BAS、GST申报。" },
        { heading: "SMSF设立与管理", body: "自管养老金设立、年度合规及审计协调。" },
        { heading: "公司与信托架构设立", body: "为Box Hill创业者提供ABN/ACN/GST注册、家庭信托设立及企业架构建议。" },
        { heading: "物业税务建议", body: "租赁物业扣减、折旧报告与CGT规划——契合Box Hill活跃的出租与投资物业市场。" },
      ],
    },
    {
      heading: "我们的合作流程",
      list: [
        { heading: "1. 咨询", body: "在Canterbury办公室（距Box Hill仅10分钟）面谈,或预约视频通话。" },
        { heading: "2. 定制方案", body: "根据您的情况——个人、企业或SMSF——提供透明固定报价的服务计划。" },
        { heading: "3. 全程处理", body: "由我们的CPA与注册税务代理端到端处理申报、BAS及合规事项。" },
        { heading: "4. 持续支持", body: "在ATO规则、业务或投资情况变化时,全年提供顾问建议。" },
      ],
    },
  ],
},


};
export default ZH;
